import React, { useRef, useEffect, useState } from "react";
import Button from "../../component/button/Button";
import alluraFont from "../../config/onboarding/allura-font";
import "../../styles/pages/welcome.scss";
import Label from "../../component/label/Label";
import {
  createCandidateDataDocuments,
  getCandidateData,
  loderControl,
  loderOffControl,
} from "../../redux/slices/newRoleSlices";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, FieldArray } from "formik";
import FormikControl from "../../formikControl/FormikControl";
import Model from "../../component/modal/Modal";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useNavigate } from "react-router-dom";
import { apiPost } from "../../service/apiService";
import { endPoint } from "../../config/endPoint";
import { Modal } from "react-bootstrap";
import Loader from "../../component/loader/Loader";
import Iframe from "../../component/formikComponent/Iframe";

import { toast } from "react-toastify";
import {
  domainWithHttp,
  oldFile,
  stepes,
  updateOldFile,
} from "../../config/onboarding/onBoarding";
import Image from "../../component/image/Image";
import Bin from "../../assets/images/bin.png";
import DocIcon from "../../assets/images/doc-icon.svg";
import "../../styles/timeline.scss";
import "../../styles/pages/onboarding-refresh.scss";
import Slider from "react-slick";
import FormButtons from "./components/FormButtons";
import IframeSection from "./components/IframeSection";
import ErrorSummary from "./components/ErrorSummary";
import exportPDF from "./utils/exportPDF";
import { checkDocumentSignedStatus } from "./utils/flkSignedStatus";
import { applyBodyClass } from "./utils/themeUtils";
import { applyFlkTheme, removeAllFlkThemes, applyThemeFromFormData } from "./utils/flkThemeManager";
import useSkipDualForm from "./hooks/useSkipDualForm";
interface CandidateData {
  activeStyle: boolean;
  candidateId: string;
  clientId: string;
  fields: any[];
  formId: string;
  label: string;
  active?: boolean;
  indata?: any;
  data?: any[];
  isTFNForm?: number;
  isSuperForm?: number;
  flk_config?: any;
  currentPage?: boolean;
  currentPageStyle?: string;
  completedPage?: string;
}

type FlkFormType = "TFN" | "SUPER" | "DYNAMIC" | null;
type FlkState = {
  type: FlkFormType;
  formIndex: number | null;
  signingUrl: string;
  signedUrl: string;
  isSigned: boolean;
  hasChanges: boolean;
  formName?: string;
};


let formstatus = "draft";
let checkTimeline = "";
export let valudatesetformstatus = "";

export const updateValudatesetFormstatus = (params: any) => {
  valudatesetformstatus = params;
};

let formstatusTwo = false;
export let checkValidationElement: any = [];

export const setchioldValidation = (params: any) => {
  checkValidationElement = params;
};

export let childDisplay: any = {};
let apiIndex = 0;
let fileValue = 0;
let changeParams: any = null;

const OnBoarding = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const candidateData = useSelector((state: any) => {
    return state?.newRole?.candidateData;
  });

  const loader = useSelector((state: any) => {
    return state?.newRole?.loading;
  });
  const candidateDataDocuments = useSelector((state: any) => {
    return state?.newRole?.createCandidateDataDocuments;
  });
  const [updateFormData, setUpdateFormData] = useState<CandidateData[]>([]);

  const formRef = useRef<any>([]);
  const [screenShort, setScreenShort] = useState({
    active: true,
  });

  const [pageResload, setPageReload] = useState(false);

  //dynamic flk
  const [flkState, setFlkState] = useState<FlkState>({
    type: null,
    formIndex: null,
    signingUrl: "",
    signedUrl: "",
    isSigned: false,
    hasChanges: false,
    formName: "",
  });

  // Track all changes to flkState
  useEffect(() => {
    const dynamicClassName = updateFormData[flkState.formIndex || 0]?.flk_config?.className || null;
    applyFlkTheme(flkState.type, dynamicClassName);
  }, [flkState]);


  const [isLastPage, setIsLastPage] = useState(false);
  const [candidateId, setCandidateId] = useState("");

  // this handles sign for multiple fields in the form
  const [candidateSignModel, setCandidateSignModel] = useState<{ [key: string]: string }>({});

  const [doTfnFormValidation, setDoTfnFormValidation] = useState("");

  const [countControl, setCountControl] = useState({
    show: false,
    uploadList: 0,
    fileCount: 0,
    fileUrls: [],
    saveModel: false,
    saveDraftTest: false,
    fileUplaod: false,
    parentage: 0,
    pageReload: false,
    timelineUpdate: false
  });

  const [iframeData, setIframeData] = useState({
    data: [],
    index: null,
    apiCall: false,
    errorSign: false,
    sigcontrol: false,
  });

  const ref = useRef(null);

  const [saveModel, setSaveModel] = useState(false);

  const [totalFile, setTotalFile] = useState<any>([]);
  const [movinIndex, setMovingIndex] = useState({
    fieldIndex: 0,
    fileIndex: 0,
    indexClose: false,
    totalFileUploadIndex: 0,
  });
  const [fileUploadValue, setFileUploadValue] = useState(0);
  const [uploadFileUrl, setUplaodFileUrl] = useState<any>([]);
  const [saveAndExitModel, setSveAndExitModel] = useState(false);
  const [saveToExitModel, setSaveToExitModel] = useState(false);
  const [dataIsUpdated, setDataIsUpdated] = useState(false);
  const [clearChilInput, setClearChilInput] = useState(false);
  const [slickStyleUpdate, setSlickStyleUpdate] = useState({
    index: 5,
    currentPage: 0,
    nextIndex: 4
  });
  const [getScreenWidth, setGetScreenWidth] = useState({
    width: 0,
    height: 0,
    showCount: 5
  });
  const [getOrientationChange, setOrientationChange] = useState({
    timeStamp: "0"
  });
  const sliderRef = useRef<any>(null);
  const [getFilesForDeletion, setFilesForDeletion] = useState<any>([]);
  const [expiredLinkMessage, setExpiredLinkMessage] = useState("");
  const expiredToastShownRef = useRef(false);

  const extractExpiredLinkMessage = (response: any): string => {
    const statusCode = Number(
      response?.status ??
      response?.data?.statusCode ??
      response?.data?.data?.statusCode
    );
    const message =
      response?.data?.message ||
      response?.message ||
      response?.data?.data?.message ||
      "";

    if (statusCode === 403 && typeof message === "string" && message.trim()) {
      return message.trim();
    }

    if (typeof message === "string" && /link has been expired/i.test(message)) {
      return message.trim();
    }

    return "";
  };

  const handleExpiredLink = (response: any): boolean => {
    const message = extractExpiredLinkMessage(response);
    if (!message) {
      return false;
    }

    setExpiredLinkMessage((prev) => prev || message);
    dispatch(loderOffControl());
    if (!expiredToastShownRef.current) {
      toast(message, {
        type: "error",
      });
      expiredToastShownRef.current = true;
    }

    return true;
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 75,
    arrow: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          initialSlide: 2
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ],
    afterChange: (current: any) => {
      setSlickStyleUpdate((prs) => {
        return {
          ...prs,
          currentPage: current,
        };
      });

    },
    beforeChange: (currentSlide: number, nextSlide: number) => {
      setSlickStyleUpdate((prs) => {
        return {
          ...prs,
          nextIndex: getScreenWidth.showCount === 5 ? nextSlide + 4 : nextSlide + 2
        };
      });
    }

  };

  // useEffect(() => {
  //   dispatch<any>(clientSettingsConfig());
  // }, []);

  useEffect(() => {
    if (screen.width < 575) {
      setGetScreenWidth((prs: any) => {
        return {
          ...prs,
          width: screen.width,
          showCount: 3
        };
      });
    }
    applyBodyClass("cust-template-new-page-id-1");
  }, []);

  // Auto-submit form for skipDualForm configuration
  useSkipDualForm({
    updateFormData,
    flkState,
    formRef,
  });

  const handleOrientationChange = (e: any) => {
    setOrientationChange((orientationState: any) => {
      return {
        ...orientationState,
        timeStamp: e.timeStamp
      };
    });
  };
  useEffect(() => {
    window.addEventListener("orientationchange", handleOrientationChange);
  }, []);

  useEffect(() => {
    if (!countControl.saveModel && !saveModel && pageResload) {
      window.location.reload();
    }
  }, [countControl]);

  useEffect(() => {
    if (candidateData?.statusCode === 200) {

      // reset classes first
      removeAllFlkThemes();

      setFlkState({
        ...flkState,
        formIndex: null,
        signingUrl: "",
        signedUrl: "",
        isSigned: false,
        hasChanges: false,
        formName: "",
      });
    }
  }, []);

  const isEditFormDocSigned = async (candidateId: any, formType: "TFN" | "SUPER" | "DYNAMIC") => {

    // Identify active form
    // console.log("updateFormData: ", updateFormData);
    const activeForm = updateFormData.find((f) => f.active);
    const activeFormIndex = updateFormData.findIndex((f) => f.active);
    const activePageNumber = (activeFormIndex ?? 0) + 1;
    const formName = activeForm?.label || "";

    // Call helper to check if doc is signed
    const docsPayload = await checkDocumentSignedStatus(
      dispatch,
      candidateId,
      formName,
      activePageNumber,
      formType
    );

    // Identify which FLK form index we are editing
    const specialFormIndex = updateFormData.findIndex((f: any) => {
      return formType === "TFN"
        ? f.isTFNForm === 1
        : formType === "SUPER"
          ? f.isSuperForm === 1
          : f.flk_config?.isDynamicFlkForm;
    });

    if (docsPayload === "Form Signed") {
      // Update unified FLK state
      setFlkState((prev) => ({
        ...prev,
        isSigned: true,
        signingUrl: "",
        hasChanges: false,
      }));

      const formData = [...updateFormData];
      const currentFormIndex = specialFormIndex ?? 0;
      const nextFormIndex = currentFormIndex + 1;

      if (formType === "TFN" || formType === "SUPER" || formType === "DYNAMIC") {
        if (formData[currentFormIndex]) {
          formData[currentFormIndex].active = true;
        }
      }
      //added - 27/11/25
      else{
        formData[nextFormIndex].active = true;
        formData[currentFormIndex].active = false;
        // Update main form state
        setUpdateFormData(formData);
      }

      // Handle last page
      // if (formData.length === currentFormIndex + 1) {
      //   setIsLastPage(true);
      //   setFileUploadValue(100);
      // }

    } else {
      // console.log("is it coming in showEditFlkForm");
      // toast("Please sign the document.", {
      //   type: "error",
      //   autoClose: 60000,
      // });

      // Reset unified FLK state
      setFlkState((prev) => ({
        ...prev,
        isSigned: false,
        signingUrl: "",
        signedUrl: "",
      }));
    }
  };

  /**
 * Check if the active TFN or Super form is signed.
 * 
 * If the document is signed:
 * - Mark current form as completed
 * - Move to the next form
 * - Reset signing URLs and state flags
 * - Handle last-page completion logic
 * 
 * Otherwise, show an error toast.
 */
  const isDocSigned: (
    params: any,
    formName: string,
    activePageNumber: number
  ) => Promise<void> = async (params, formName, activePageNumber) => {
    // console.log("in isDocSigned");

    // Identify the active FLK form (TFN or SUPER or DYNAMIC)
    const activeFlkForm: any = updateFormData.find((f: any) => f.active && (
      f.isTFNForm === 1 ||
      f.isSuperForm === 1 ||
      f.flk_config?.isDynamicFlkForm
    ));
    if (!activeFlkForm) {
      return;
    }
    const formType = activeFlkForm.isTFNForm === 1
      ? "TFN"
      : activeFlkForm.isSuperForm === 1
        ? "SUPER"
        : "DYNAMIC";

    const specialFormIndex = activeFlkForm.index ?? 0;

    // Call helper to check if doc is signed
    const docsPayload = await checkDocumentSignedStatus(
      dispatch,
      candidateId,
      formName,
      activePageNumber,
      formType
    );

    if (docsPayload === "Form Signed") {
      // Update unified FLK state
      setFlkState((prev) => ({
        ...prev,
        isSigned: true,
        signingUrl: "",
      }));

      const formData = [...updateFormData];
      const currentFormIndex = specialFormIndex;
      const nextFormIndex = currentFormIndex + 1;

      // If it's the last form
      if (formData.length === currentFormIndex + 1) {
        if (formData[currentFormIndex]) {
          formData[currentFormIndex].active = true;
          formData[currentFormIndex].currentPage = true;
        }
      } else {
        // Mark next form active
        if (formData[nextFormIndex]) {
          formData[nextFormIndex].active = true;
          formData[nextFormIndex].currentPage = true;
        }

        // Mark current form completed
        if (formData[currentFormIndex]) {
          formData[currentFormIndex].active = false;
          formData[currentFormIndex].currentPage = false;
          formData[currentFormIndex].completedPage = "true";
        }

        // Apply theme for the next form
        const nextForm: any = formData[nextFormIndex];
        applyThemeFromFormData(nextForm);

        document.getElementById(`personal-details-${nextFormIndex}`)?.classList.replace("d-none", "d-flex");
      }

      // Update global state
      setUpdateFormData(formData);
      // Remove all old change flags
      setFlkState((prev) => ({ ...prev, hasChanges: false }));

      // Handle last page
      if (formData.length === currentFormIndex + 1) {
        setIsLastPage(true);
        setFileUploadValue(100);
      }
    } else {
      toast("Please sign the document.", {
        type: "error",
        autoClose: 60000,
      });
    }
  };

  const showEditFlkForm = async (): Promise<void> => {
    if (!flkState.type) { return; }

    // Reset unified signing state
    setFlkState((prev) => ({
      ...prev,
      signingUrl: "",
      signedUrl: "",
      isSigned: false,
    }));

    // Call existing API with unified formType
    await isEditFormDocSigned(candidateId, flkState.type);

    let formData: any = [...updateFormData];

    // Find the position of the active FLK form
    const flkFormPosition = formData.findIndex((ress: any) =>
      flkState.type === "TFN"
        ? ress?.isTFNForm === 1
        : flkState.type === "SUPER"
          ? ress?.isSuperForm === 1
          : ress?.flk_config?.isDynamicFlkForm
    );

    // Activate only the FLK form and deactivate others
    formData = formData.map((element: any, index: number) => ({
      ...element,
      active: index === flkFormPosition,
    }));

    setFlkState((prev) => ({
      ...prev,
      hasChanges: false,
    }));
    
    // Save updates
    setUpdateFormData(formData);

    // Show the section in DOM
    document
      .getElementById(`personal-details-${flkFormPosition}`)
      ?.classList.replace("d-none", "d-flex");

    // Theme handling
    const customClassName = flkState.type === "DYNAMIC"
      ? formData[flkFormPosition]?.flk_config?.className
      : null;
    applyFlkTheme(flkState.type, customClassName);
  };

    //function to check if form is dynamic flk and doc is not signed then show toast else continue as normal tfn/super
  const handleDynamicFlkEditBtnClick = async (type: string, formName: string): Promise<void> => {
    if (type !== "DYNAMIC") { return; }
    const activeFormIndex = updateFormData.findIndex((f) => f.active);
    const activePageNumber = (activeFormIndex ?? 0) + 1;

    // Call helper to check if doc is signed
    const docsPayload = await checkDocumentSignedStatus(
      dispatch,
      candidateId,
      formName,
      activePageNumber,
      type
    );

    if (docsPayload !== "Form Signed") {
      toast("Please go back from top left to edit the form.", {
        type: "info",
        autoClose: 5000,
      });
    }else{
      showEditFlkForm();
    }
  };

  useEffect(() => {
    if (candidateData?.statusCode === 200) {

      if (!document.body.classList.contains("onboarding")) {
        applyBodyClass("onboarding");
      }

      const navigateTo = sessionStorage.getItem("navigateTo");

      if (!navigateTo) {
        sessionStorage.setItem("navigateTo", candidateData?.currentPage);
      }

      setIsLastPage(candidateData?.data.length <= candidateData?.currentPage);
      setCountControl((prs) => {
        return {
          ...prs,
          show: false,
          timelineUpdate: false
        };
      });
      setScreenShort((prs) => {
        return {
          ...prs,
          active: true,
        };
      });

      /*
      * currentPage : "-1" means first time onboarding
      * currentPage : "-2" means all forms finished
      */
      if (candidateData?.currentPage === -2 || candidateData?.currentPage === "-2") {
        navigate("/getCandidate/onboarding-result");
        dispatch(loderControl());
        return;
      } else if (candidateData?.currentPage === "-1" || candidateData?.currentPage === -1) {
        navigate(`/getCandidate/${sessionStorage.getItem("clientId")}`);
        dispatch(loderControl());
        return;
      }

      dispatch(loderOffControl());

      const candidateDataRess = { ...candidateData };
      candidateDataRess.finalStep = candidateDataRess.finalStep ? candidateDataRess.finalStep : 0;
      if (navigateTo) {
        candidateDataRess["currentPage"] = Number(navigateTo);
      }

      // Detect FLK form in the candidate data (local vars used immediately)
      let flkIndex: number | null = null;
      let flktype: "TFN" | "SUPER" | "DYNAMIC" | null = null;

      candidateDataRess?.data?.forEach((ress: any, j: number) => {
        // console.log("ress", ress.isSuperForm);
        if (!ress.active) { return; }
        if (ress.isTFNForm === 1) {
          flkIndex = j;
          flktype = "TFN";
        }

        if (ress.isSuperForm === 1) {
          flkIndex = j;
          flktype = "SUPER";
        }

        // dynamic flk iframe
        if (ress?.flk_config && ress.flk_config?.isDynamicFlkForm) {
          flkIndex = j;
          flktype = "DYNAMIC";
        }
      });

      // console.log("flktype", flktype,"flkIndex", flkIndex);

      // Update unified flkState (async) — but we will use local flktype/flkIndex in this effect to avoid race issues
      // if (flktype && flkIndex !== null) {
      //   setFlkState(prev => ({
      //     ...prev,
      //     type: flktype,
      //     formIndex: flkIndex
      //   }));
      // }

      // If we're not on the FLK form page, clear signing urls (use setFlkState)
      if (
        flkIndex !== null &&
        candidateData?.currentPage !== flkIndex + 1
      ) {
        setFlkState((prev) => ({
          ...prev,
          signingUrl: "",
          signedUrl: "",
        }));
      }

      let dobValue: null | Date = null; //for dob prefill
      // console.log("before - candidateDataRess", candidateDataRess);
      // Build modified form data — use local flktype/flkIndex inside the mapping to avoid state timing issues.
      const modifideFormData = candidateDataRess?.data.map(
        (data: any, i: number) => {
          const indata: any = {};
          const control = { ...data };
          control.index = i;
          control.active = false;
          control.currentPage = false;
          control.currentPageStyle = "";

          if (
            (candidateDataRess?.currentPage === "-1" && i === 0) ||
            (i === 0 && candidateDataRess?.currentPage === 1)
          ) {
            control.active = true;
            control.currentPage = true;
            control.currentPageStyle = "current-page";
          } else if (candidateDataRess?.currentPage > i + 1) {
            control.completedPage = true;
            control.currentPageStyle = "current-page";
          } else if (candidateDataRess?.currentPage === i + 1) {
            // If iframe is showing for the FLK form page, hide form and keep timeline current
            if (
              flktype === "TFN" &&
              flkState.signingUrl !== "" &&
              flkIndex !== null &&
              candidateDataRess.currentPage === flkIndex + 1
            ) {
              control.active = false;
              control.currentPage = true;

            } else if (
              flktype === "SUPER" &&
              flkState.signingUrl !== "" &&
              flkIndex !== null &&
              candidateDataRess.currentPage === flkIndex + 1
            ) {
              control.active = false;
              control.currentPage = true;
            } else if (
              flktype === "SUPER" &&
              flkState.signedUrl !== "" &&
              flkState.signedUrl !== null &&
              flkIndex !== null &&
              candidateDataRess.currentPage === (flkIndex + 1)
            ) {
              // SUPER signed preview case (preserve original behavior)
              control.active = false;
              control.currentPage = true;
            } else if (
              flktype === "TFN" &&
              flkState.signedUrl !== "" &&
              flkState.signedUrl !== null &&
              flkIndex !== null &&
              candidateDataRess.currentPage === (flkIndex + 1)
            ) {
              // TFN signed preview case (restored)
              control.active = false;
              control.currentPage = true;
            } else {
              control.active = true;
              control.currentPage = true;
            }

          }

          // finalStep behavior — replaced old isTfnForm with flktype check
          if (candidateDataRess?.finalStep > i + 1) {
            if (flktype !== "TFN") {
              control.currentPageStyle = "current-page";
              control.completedPage = true;
            } else {
              //control.currentPage = true;
            }
          } else if (candidateDataRess?.currentPage === i + 1) {
            control.currentPageStyle = "current-page";
          }

          if (candidateDataRess?.currentPage === i + 1) {
            if (flkState.signingUrl !== "" && flkState.formIndex === i) {
              control.currentPage = true;
            } else {
              control.currentPage = true;
            }
          }

          // Unified FLK Form Logic (TFN / SUPER / DYNAMIC) — using local flktype/flkIndex and flkState urls
          if (
            flktype &&
            flkIndex === i
          ) {
            // When iframe is shown, timeline shouldn't mark page as completed
            if (flkState.signingUrl !== "") {
              control.completedPage = false;
            }

            // If iframe is open on current form page → hide actual form, show iframe
            if (
              flkState.signingUrl !== "" &&
              candidateDataRess.currentPage === flkIndex + 1
            ) {
              document
                .getElementById("personal-details-" + flkIndex)
                ?.classList.add("d-none");
              control.active = true;
            }

            // If iframe is hidden (signingUrl empty) → show the form again
            else if (
              flkState.signingUrl === "" &&
              data?.active === true
            ) {
              document
                .getElementById("personal-details-" + flkIndex)
                ?.classList.replace("d-none", "d-flex");

              if (valudatesetformstatus === "draft") {
                control.active = true;
                // ensure FLK form shows rather than iframe
                setFlkState(prev => ({
                  ...prev,
                  signingUrl: ""
                }));
              }
            }
          }

          // When FLK iframe is closed → show the actual form again (combined TFN/SUPER/DYNAMIC)
          if (
            flkState.signingUrl === "" &&
            flkIndex === i &&
            candidateDataRess.currentPage === flkIndex + 1
          ) {
            // Show the form section
            document
              .getElementById("personal-details-" + flkIndex)
              ?.classList.replace("d-none", "d-flex");

            // Remove all FLK themes (they will be reapplied based on current form type)
            removeAllFlkThemes();
          }

          const sunFormIndate1: any = [];
          const sunFormIndate2: any = [];
          const sunFormIndate3: any = [];

          let sunIndexIndateCount = 0;
          const formFields = control?.fields?.map((element: any) => {
            const element1 = { ...element };
            if (element.firstName) {
              localStorage.setItem("clindFirstName", element.value);
            }

            if (element?.isSignature === true) {
              // setCandidateSignModel(element?.value);
              setCandidateSignModel(prev => ({
                ...prev,
                [element?.name]: element?.value,
              }));
            }
            // get subform 1 value
            if (element?.subForm && element.name === "subForm-1") {
              const obj: any = {};
              element.subForm.forEach((item: any, i: number) => {
                if (item.type === "date") {
                  if (item.value) {
                    obj[item.name] = new Date(item.value);
                  } else {
                    obj[item.name] = item.value;
                  }
                } else {
                  if (item.type === "file") {
                    obj[item.name] = item.value;
                    oldFile[`subForm_1.${sunIndexIndateCount}.${item.name}`] =
                      item.value;
                  } else {
                    obj[item.name] = item.value;
                  }
                }
              });
              sunFormIndate1.push(obj);
              sunIndexIndateCount = sunIndexIndateCount + 1;
              indata.subForm_1 = sunFormIndate1;
            }
            //  get subform 2 value
            if (element?.subForm && element.name === "subForm-2") {
              const obj: any = {};
              element.subForm.forEach((item: any, i: number) => {
                if (item.type === "date") {
                  if (item.value) {
                    obj[item.name] = new Date(item.value);
                  } else {
                    obj[item.name] = item.value;
                  }
                } else {
                  if (item.type === "file") {
                    const subFormIndex1 = control?.fields.filter(
                      (ress: any) => ress.name === "subForm-1"
                    );
                    obj[item.name] = item.value;
                    oldFile[
                      `subForm_2.${sunIndexIndateCount - subFormIndex1.length
                      }.${item.name}`
                    ] = item.value;
                  } else {
                    obj[item.name] = item.value;
                  }
                }
              });
              sunFormIndate2.push(obj);
              sunIndexIndateCount = sunIndexIndateCount + 1;
              indata.subForm_2 = sunFormIndate2;
            }

            //  get subform 3 value
            if (element?.subForm && element.name === "subForm-3") {
              const obj: any = {};
              element.subForm.forEach((item: any, i: number) => {
                if (item.type === "date") {
                  if (item.value) {
                    obj[item.name] = new Date(item.value);
                  } else {
                    obj[item.name] = item.value;
                  }
                } else {
                  if (item.type === "file") {
                    const subFormIndex1 = control?.fields.filter(
                      (ress: any) => ress.name === "subForm-1"
                    );
                    obj[item.name] = item.value;
                    oldFile[
                      `subForm_3.${sunIndexIndateCount - subFormIndex1.length
                      }.${item.name}`
                    ] = item.value;
                  } else {
                    obj[item.name] = item.value;
                  }
                }
              });
              sunFormIndate3.push(obj);
              sunIndexIndateCount = sunIndexIndateCount + 1;
              indata.subForm_3 = sunFormIndate3;
            }

            if (element.type === "date") {
              // Capture DOB once
              if (element.label === "Date of Birth" && element.value) {
                dobValue = element.value;
              }
              // Default behavior (same as old code)
              let finalValue = element.value;
              // New feature: prefill DOB-based field
              if (!finalValue && element?.dob && dobValue) {
                finalValue = dobValue;
              }
              indata[element.name] = finalValue ? new Date(finalValue) : finalValue;
            } else if (element.type === "radio-group") {
              if (element?.is_child_validate === null) {
                childDisplay = {
                  parentName: element.name,
                  child_display: element.child_display?.map((ress: any) => {
                    return ress.child_display_id;
                  }),
                  visibleArray: element.child_display,
                  hideName: null,
                };
              }
              indata[element.name] = element.value;
            } else if (element.type === "select") {
              if (element.is_child_validate) {
                if (element?.child_validate?.parent_validate_value) {
                  checkValidationElement.push({
                    parent_value: element.child_validate.parent_validate_value,
                    child_name: element.child_validate.child_validate_id,
                    parent_name: element.name,
                  });
                }
                if (element?.child_display && element.child_display.length > 0) {
                  childDisplay = {
                    parentName: element.name,
                    child_display: element.child_display?.map((ress: any) => {
                      return ress.child_display_id;
                    }),
                    visibleArray: element.child_display,
                    hideName: null,
                  };
                }
              }
              indata[element.name] = element.value;
            } else if (element.type === "multiSelect") {
              if (element.is_child_validate) {
                if (element?.child_display) {
                  checkValidationElement.push({
                    parent_value: element.child_display.map((e: any) => e?.parent_validate_value),
                    child_name: element.child_display[0].child_display_id,
                    parent_name: element.name,
                  });
                }
              }
              indata[element.name] = element.value;
            }
            else if (element.type === "split-input") {
              if (element.validate) {
                indata[`${element.name}-0`] = element.value;
              }

              if (element.value) {
                const splitLength = Array(element?.boxCount).fill(null);
                splitLength.forEach((_: any, index: number) => {
                  indata[`${element.name}-${index}`] = element.value[index];
                });

              }
              indata[element.name] = element.value;
            } else if (element.type === "file") {
              indata[element.name] =
                element.value !== undefined ? element.value : [];
              oldFile[element.name] =
                element.value !== undefined ? element.value : [];
            } else {
              if (element.type === "iframe") {
                const obj = { ...element };
                obj.index = i;
                indata[element.name] = element.value;
                setIframeData((prs: any) => {
                  return {
                    ...prs,
                    data: [...prs.data, obj],
                  };
                });
              } else {
                if (element?.firstName && !element.value) {
                  indata[element.name] =
                    candidateData?.candidateDetails?.firstName;
                  element1["value"] = candidateData?.candidateDetails?.firstName;
                } else if (element?.lastName && !element.value) {
                  indata[element.name] =
                    candidateData?.candidateDetails?.lastName;
                  element1["value"] = candidateData?.candidateDetails?.lastName;
                } else if (element?.fullName && !element.value) {
                  indata[element.name] =
                    candidateData?.candidateDetails?.fullName;
                  element1["value"] = candidateData?.candidateDetails?.firstName + " " + candidateData?.candidateDetails?.lastName;
                } else if (element?.email && !element.value) {
                  indata[element.name] = candidateData?.candidateDetails?.email;
                  element1["value"] = candidateData?.candidateDetails?.email;
                } else if (element?.phone && !element.value) {
                  indata[element.name] = candidateData?.candidateDetails?.phone;
                  element1["value"] = candidateData?.candidateDetails?.phone;
                } else if (element?.positionApplied && !element.value) {
                  indata[element.name] = candidateData?.candidateDetails?.jobName + " (" + candidateData?.candidateDetails?.jobReferenceId + ")";
                  element1["value"] = candidateData?.candidateDetails?.jobName + " (" + candidateData?.candidateDetails?.jobReferenceId + ")";
                } else if (
                  element.name !== "subForm-1" &&
                  element.name !== "subForm-2" &&
                  element.name !== "subForm-3"
                ) {
                  indata[element.name] = element.value;
                }
              }
            }
            return element1;
          });
          return { ...control, indata: indata, fields: formFields };
        }
      );
      // console.log("after - modifideFormData", modifideFormData);

      let newFlkType: "TFN" | "SUPER" | "DYNAMIC" | null = null;
      let formName = "";
      if (modifideFormData.length && modifideFormData.some((f: any) => f.active)) {

        const flkIndex = modifideFormData.findIndex((f: any) => f.active);
        const flktype = modifideFormData[flkIndex].type;
        if (modifideFormData[flkIndex].isTFNForm === 1) {
          newFlkType = "TFN";
        }
        if (modifideFormData[flkIndex].isSuperForm === 1) {
          newFlkType = "SUPER";
        }
        // dynamic flk iframe
        if (modifideFormData[flkIndex]?.flk_config && modifideFormData[flkIndex].flk_config?.isDynamicFlkForm) {
          newFlkType = "DYNAMIC";
          formName = modifideFormData[flkIndex].flk_config?.dynamicFormName;
        }

        setFlkState(prev => ({
          ...prev,
          type: newFlkType,
          formName: formName,
          formIndex: flkIndex
        }));
      }

      // Apply correct theme based on active FLK form
      // console.log("flktype local", flktype, flkIndex);
      const customClassName = flktype === "DYNAMIC" && flkState.formIndex !== null
        ? candidateDataRess?.data?.[flkState.formIndex]?.flk_config?.className
        : null;
      applyFlkTheme(newFlkType, customClassName);

      setUpdateFormData(modifideFormData);

    } else if (candidateData?.statusCode === 403) {
      handleExpiredLink(candidateData);
    } else if (candidateData === null || candidateData?.statusCode === 400) {
      navigate("*");
    }
  }, [candidateData]);


  useEffect(() => {
    if (candidateDataDocuments !== null) {
      if (handleExpiredLink(candidateDataDocuments)) {
        return;
      }
      if (candidateDataDocuments.status === 200) {
        const obj: any = {};
        obj["clientId"] = sessionStorage.getItem("clientId");
        obj["domainWithHttp"] = domainWithHttp;
        dispatch<any>(
          getCandidateData(obj)
        );
      }
    }
  }, [candidateDataDocuments]);

  //check latest formData to indentify active form
  useEffect(() => {
    if (updateFormData.length) {
      // console.log(updateFormData.find(e => e.active));
      const activeForm = updateFormData.find(e => e.active);
      setFlkState(prev => ({
        ...prev,
        formName: activeForm?.flk_config?.dynamicFormName || "",
        type: activeForm?.isTFNForm === 1
          ? "TFN"
          : activeForm?.isSuperForm === 1
            ? "SUPER"
            : activeForm?.flk_config?.isDynamicFlkForm
              ? "DYNAMIC"
              : null,
      }));
    }
  }, [updateFormData]);

  const candidateSignatures = (signData: any) => {
    // const signElement = document.getElementsByName(signData);
    // if (signElement) {
    //   setCandidateSignModel((signElement[0] as HTMLInputElement).value);
    // }    
    const signElement = document.getElementsByName(signData);
    if (signElement && signElement[0]) {
      setCandidateSignModel(prev => ({
        ...prev,
        [signData]: (signElement[0] as HTMLInputElement).value,
      }));
    }
  };

  const fileNameModifide = (fileData: any) => {
    const aaaWithoutExtension = fileData?.file?.name.replace(/\.[^.]+$/, "");
    let result = "";
    if (aaaWithoutExtension?.length > 30) {
      const lastDotIndex = fileData?.file?.name?.toString()?.lastIndexOf(".");
      const extension = fileData?.file?.name?.substring(lastDotIndex + 1);
      const prifix = fileData?.file?.name?.substring(0, 15);
      const subfix = aaaWithoutExtension?.slice(-10);
      result = prifix + "..." + subfix + "." + extension;
    } else {
      result = fileData?.file?.name;
    }
    return result;
  };

  const deleteFilesFromServer = async () => {
    const pathParamObj: any = {};
    pathParamObj["clientId"] = sessionStorage.getItem("clientId");
    pathParamObj["domainWithHttp"] = domainWithHttp;
    const response = await apiPost(endPoint.deleteFile, { fileUrl: getFilesForDeletion }, pathParamObj);
    return response;
  };


  const finalUserInput = (splitLength: any, name: any) => {
    const values: any[] = [];
    splitLength.forEach((_: any, index: number) => {
      const element = document.getElementById(`${name}-${index}`);
      const fieldInputValue: any = element ? (element as HTMLInputElement).value : "";
      if (fieldInputValue !== "") {
        values.push(fieldInputValue);
      } else {
        values.push(" ");
      }
    });
    return values.join("").toUpperCase().trim();
  };


  const clearValueForChildElement = () => {
    setClearChilInput(true);
  };

  // Check parent value match for child display
  const checkParentMatch = (data: any, formikValues: any) => {
    const fieldValue = formikValues?.[data.parentName] || [];
    // Case 1: Multi select
    if (Array.isArray(data.parentValues) && Array.isArray(fieldValue)) {
      // extract only the values from [{label, value}, ...]
      const selectedValues = fieldValue.map((item: any) => item.value);

      // check if ANY of the parentValues exist in selectedValues
      return data.parentValues.some((val: string) => selectedValues.includes(val));
    }
    // Case 2: Single select or text
    if (data.parentValue) {
      return fieldValue === data.parentValue;
    }
    // Case 3: Single select with multiple parentValues
    if (Array.isArray(data.parentValues)) {
      return data.parentValues.includes(fieldValue);
    }

    return true; // by default show the field if no specific condition is set
  };

  const submitCandidateData = async (params: any) => {
    if (formstatusTwo) {
      formstatus = "draft";
    } else {
      sessionStorage.removeItem("navigateTo");
    }

    setFileUploadValue(0);
    const fd = new FormData();

    // --- LOCAL FLK SNAPSHOT (no stale state issues)
    // console.log("flkState", flkState);
    const flk = {
      type: flkState.type,
      formIndex: flkState.formIndex,
      signingUrl: flkState.signingUrl,
      signedUrl: flkState.signedUrl,
      isSigned: flkState.isSigned,
      hasChanges: flkState.hasChanges
    };

    // We still detect active TFN/SUPER using params (unchanged backend logic)
    let tfnFormIndexLocal: number | null = null;
    let superFormIndexLocal: number | null = null;
    let dynamicFormIndexLocal: number | null = null;
    let isActiveTfnFormSubmit = false;
    let isActiveSuperFormSubmit = false;
    let isActiveDynamicFormSubmit = false;


    params.forEach((ress: any, i: number) => {
      if (!ress.active) { return; }

      // Detect active TFN/SUPER form
      if (ress.isTFNForm === 1) {
        tfnFormIndexLocal = i;
        isActiveTfnFormSubmit = true;
      }
      if (ress.isSuperForm === 1) {
        superFormIndexLocal = i;
        isActiveSuperFormSubmit = true;
      }
      if (ress?.flk_config && ress.flk_config?.isDynamicFlkForm) {
        dynamicFormIndexLocal = i;
        isActiveDynamicFormSubmit = true;
      }

      // Handle split-input fields for the active form
      ress.fields?.forEach((field: any, k: number) => {
        if (field?.type === "split-input") {
          const splitLength = Array(field.boxCount).fill(null);
          const finalValue = finalUserInput(splitLength, field.name);

          fd.append(field.name, finalValue);

          // keep backend logic same: update the appropriate param value
          if (tfnFormIndexLocal === i) {
            params[i].fields[k].value = finalValue;
          }
          if (superFormIndexLocal === i) {
            params[i].fields[k].value = finalValue;
          }
        }
      });
    });


    // If signed via iframe → mark no changes
    if (flk.isSigned) {
      // Now unified:
      flk.hasChanges = false;
    }

    // ---------------------------
    // SUPER form template (same)
    // ---------------------------
    let flkTemplateName = "";
    if (superFormIndexLocal !== null) {
      params?.[superFormIndexLocal]?.fields
        .filter((f: any) => f?.superFormTemplateId === 1)
        .forEach((f: any) => {
          const selected = f?.values?.find((opt: any) => opt?.value === f?.value);
          fd.append("flkTemplateName", selected?.tfnTemplateName || flkTemplateName);
        });
    } else {
      fd.append("flkTemplateName", flkTemplateName);
    }

    // ------------------------------------
    // MAIN LOOP — backend payload preserved
    // ------------------------------------
    let base64Image: any = null;

    for (let i = 0; i < params.length; i++) {
      const ress = params[i];
      if (!ress.active) { continue; }

      // DRAFT
      if (formstatus === "draft") {
        fd.append("formStatus", "draft");
      } else {
        // Generate PDF for only active form
        /* eslint-disable no-await-in-loop */
        base64Image = await exportPDF({
          params,
          index: i,
          alluraFont,
          candidateData,
          fileNameModifide
        });

        const isDynamicFlkForm = ress?.flk_config && ress.flk_config?.isDynamicFlkForm;
        if (ress.isTFNForm !== 1 && ress.isSuperForm !== 1 && !isDynamicFlkForm) {
          fd.append(
            "formStatus",
            updateFormData.length !== i + 1 ? "submit" : "complete"
          );
        } else {
          // ----------------------------
          // UNIFIED TFN/SUPER/DYNAMIC DECISION
          // ----------------------------
          const belongsToFLK =
            (ress.isTFNForm === 1 && flk.type === "TFN") ||
            (ress.isSuperForm === 1 && flk.type === "SUPER") ||
            (isDynamicFlkForm && flk.type === "DYNAMIC");

          const considerSigned = flk.isSigned || flk.signedUrl !== "";

          if (belongsToFLK && considerSigned) {
            if (isLastPage) {
              fd.append("formStatus", "complete");
            } else {
              const canComplete =
                params.length === 1 && !flk.hasChanges && considerSigned;

              fd.append("formStatus", canComplete ? "complete" : "submit");
            }
          } else if (flk.signingUrl !== "" && belongsToFLK) {
            fd.append("formStatus", "submit");
          } else {
            fd.append("formStatus", "submit");
          }
        }
      }

      // currentPage (same)
      fd.append("currentPage", (i + 1).toString());

      // -------------------------------
      // BACKEND PAYLOAD FIELD — SAME
      // -------------------------------
      fd.append("isActiveTfnForm", ress.isTFNForm === 1 ? "1" : "0");
      fd.append(
        "isTfnFormChanged",
        ress.isTFNForm === 1 && flk.hasChanges ? "1" : "0"
      );

      fd.append("isActiveSuperForm", ress.isSuperForm === 1 ? "1" : "0");
      fd.append(
        "isSuperFormChanged",
        ress.isSuperForm === 1 && flk.hasChanges ? "1" : "0"
      );

      //add dynamic flk form data
      if (ress?.flk_config && ress.flk_config?.isDynamicFlkForm) {
        fd.append("isDynamicFlkForm", "1");
        fd.append("isDynamicFlkFormChanged", flk.hasChanges ? "1" : "0");
      } else {
        fd.append("isDynamicFlkForm", "0");
        fd.append("isDynamicFlkFormChanged", "0");
      }

      // unchanged metadata
      fd.append("candidateId", ress.candidateId);
      fd.append("clientId", ress.clientId);
      fd.append("formName", ress.label);
      fd.append(
        "finalStep",
        candidateData.finalStep === null ? "0" : String(candidateData.finalStep)
      );
      fd.append("navigateTo", sessionStorage.getItem("navigateTo") || "");

      if (formstatus !== "draft") {
        fd.append(
          "pdfDoc",
          base64Image.split(
            "data:application/pdf;filename=generated.pdf;base64,"
          )[1]
        );
      }
    }

    fd.append("data", JSON.stringify(params));

    // ---------------------
    // API CALL — SAME LOGIC
    // ---------------------
    if (checkTimeline === "") {
      const candidateDataRess = await dispatch<any>(
        createCandidateDataDocuments(fd)
      );

      if (handleExpiredLink(candidateDataRess?.payload)) {
        return;
      }

      window.scrollTo(0, 0);
      const candidatePayload = candidateDataRess?.payload?.data?.data;

      if (formstatus === "draft" && candidateDataRess?.payload?.status === 200) {
        if (!isActiveTfnFormSubmit && !isActiveSuperFormSubmit) {
          if (iframeData.sigcontrol) {
            setPageReload(true);
          } else {
            if (!saveToExitModel && !countControl.timelineUpdate) {
              setCountControl((prs) => ({
                ...prs,
                saveDraftTest: true,
                saveModel: true
              }));
            }
            setPageReload(true);
          }

          setFlkState((prev) => ({
            ...prev,
            signingUrl: "",
            signedUrl: "",
            isSigned: false
          }));
        }
      } else if (candidatePayload) {
        // backend-returned signingurl
        if (candidatePayload?.signingUrl && isActiveTfnFormSubmit) {
          setFlkState((prev) => ({
            ...prev,
            // Reason to comment: This was setting type to the CURRENT form (TFN) being submitted,
            // but we need to detect and set the NEXT active form's type instead.
            // This caused flkState to be out of sync when moving to the next form.
            // type: "TFN",
            signingUrl: candidatePayload.signingUrl,
            signedUrl: candidatePayload.signedUrl,
            isSigned: !!candidatePayload.isSigned
          }));
          localStorage.setItem("signing_url", candidatePayload?.signingUrl || "");
          localStorage.setItem("signed_url", candidatePayload?.signedUrl || "");
        } else if (candidatePayload?.superSigningUrl && isActiveSuperFormSubmit) {
          // console.log("in else if ", candidatePayload.superSigningUrl);
          setFlkState((prev) => ({
            ...prev,
            // Reason to comment: This was setting type to the CURRENT form (SUPER) being submitted,
            // but we need to detect and set the NEXT active form's type instead.
            // This caused flkState to be out of sync when moving to the next form.
            // type: "SUPER",
            signingUrl: candidatePayload.superSigningUrl,
            signedUrl: candidatePayload.superSignedUrl,
            isSigned: !!candidatePayload.superIsSigned
          }));
          localStorage.setItem("signing_url", candidatePayload?.superSigningUrl || "");
          localStorage.setItem("signed_url", candidatePayload?.superSignedUrl || "");
        } else if (candidatePayload?.dynamicSigningUrl && isActiveDynamicFormSubmit) {
          setFlkState((prev) => ({
            ...prev,
            signingUrl: candidatePayload.dynamicSigningUrl,
            signedUrl: candidatePayload.dynamicSignedUrl,
            isSigned: !!candidatePayload.dynamicIsSigned
          }));
          localStorage.setItem("signing_url", candidatePayload?.dynamicSigningUrl || "");
          localStorage.setItem("signed_url", candidatePayload?.dynamicSignedUrl || "");
        } else {
          setFlkState((prev) => ({
            ...prev,
            signingUrl: "",
            signedUrl: "",
            isSigned: false
          }));
        }

        // FIX: After form submission, detect and set the NEXT active form's FLK type
        // This ensures flkState.type and formIndex are always in sync with the currently active form
        const nextActiveForm = params.find((f: any) => f.active);
        if (nextActiveForm) {
          let nextFlkType: FlkFormType = null;
          let nextFlkIndex: number | null = null;

          if (nextActiveForm.isTFNForm === 1) {
            nextFlkType = "TFN";
            nextFlkIndex = nextActiveForm.index;
          } else if (nextActiveForm.isSuperForm === 1) {
            nextFlkType = "SUPER";
            nextFlkIndex = nextActiveForm.index;
          } else if (nextActiveForm.flk_config?.isDynamicFlkForm) {
            nextFlkType = "DYNAMIC";
            nextFlkIndex = nextActiveForm.index;
          }

          // Update flkState with the NEXT form's type and index
          setFlkState((prev) => ({
            ...prev,
            type: nextFlkType,
            formName: nextActiveForm?.flk_config?.dynamicFormName || "",
            formIndex: nextFlkIndex
          }));
        }

        setCandidateId(candidatePayload?.candidateId);
        if (candidatePayload?.signedUrl) {
          localStorage.setItem("is_signed", candidatePayload?.signedUrl);
        } else if (candidatePayload?.superSignedUrl) {
          localStorage.setItem("is_signed", candidatePayload?.superSignedUrl);
        }
      } else if (candidateDataRess?.payload?.data?.data?.signingUrl !== undefined) {
        setIframeData((prs) => ({ ...prs, errorSign: true }));
      } else {
        setScreenShort((prs) => ({ ...prs, saveModel: false }));
      }
    }
  };


  useEffect(() => {
    if (movinIndex.indexClose) {
      let apiCall = 0;
      const fileObjIndex = 0;
      let controlApiCall = 1;
      const activeFormData: any = updateFormData.filter((ress) => ress?.active);
      const obj = { ...activeFormData[0] };
      const fData = new FormData();
      const pathParamObj: any = {};
      pathParamObj["clientId"] = sessionStorage.getItem("clientId");
      pathParamObj["domainWithHttp"] = domainWithHttp;
      fData.append("clientId", obj["clientId"]);
      fData.append("candidateId", obj["candidateId"]);
      fData.append("formId", obj["formId"]);
      if (totalFile.length > 0) {
        fData.append("fieldId", totalFile[0]["name"]);
        fData.append("files", totalFile[fileObjIndex]?.value[apiCall]);
      }
      const selectedFileupload = async () => {
        const response = await apiPost(
          endPoint.createCandidateDataDocuments,
          fData,
          pathParamObj
        );

        if (handleExpiredLink(response)) {
          setSaveModel(false);
          return;
        }

        if (response.status === 200) {
          controlApiCall = controlApiCall + 1;
          const obj = {
            parentName: totalFile[fileObjIndex]?.value[apiCall]["name"],
            url: response?.data?.data?.url[0],
            fileName: response?.data?.data?.fileName,
            childName: "",
          };
          apiCall = apiCall + 1;
          setTotalFile((oldArray: any) => [
            ...oldArray.map((ress: any) => {
              return ress;
            }),
          ]);

          if (controlApiCall >= movinIndex.fileIndex) {
            selectedFileupload();
          } else {
            setMovingIndex((prs) => {
              return {
                ...prs,
                indexClose: false,
              };
            });
          }
        }
      };
      if (movinIndex.indexClose) {
        selectedFileupload();
      }
    }
  }, [totalFile, movinIndex]);

  useEffect(() => {
    if (Math.round(fileUploadValue) >= 100) {
      setSaveModel(false);

      const activeForm: any[] = updateFormData.filter(
        (ress) => (ress.active === true)
      );
      const activeFormIndex = updateFormData.findIndex((ress) => ress.active);

      let activePageNumber = (activeFormIndex ?? 0) + 1;

      const candidateId = updateFormData[0]?.candidateId;
      const formName = activeForm[0]?.label || "";

      const hasValidSignature = flkState.signingUrl?.length > 0 && !formstatusTwo;

      if (candidateId && hasValidSignature) {
        setFileUploadValue(0);
        isDocSigned(candidateId, formName, activePageNumber);
        return;
      }

      let subForm3Index = 0;

      const sendData = updateFormData.map((ress, i) => {
        const shouldProcess = (changeParams?.prsIndex === i) || ress.active;
        if (!shouldProcess) { return ress; }

        const paramsData = formRef.current[i].values;
        let subFormIndex = 0;
        let subForm3Index = 0;

        const processFileField = (fieldName: any, subFormName = null, currentIndex = null) => {
          const fieldId = subFormName
            ? `${subFormName}.${currentIndex}.${fieldName}`
            : fieldName;

          const filterFile = uploadFileUrl.filter(
            (gg: any) => gg?.file?.fieldId === fieldId
          );

          const oldFileUrls = oldFile[fieldId]?.filter(
            (aa: any) => !(aa instanceof File)
          ) || [];

          return filterFile.length > 0
            ? oldFileUrls.concat(filterFile)
            : oldFileUrls;
        };

        const getSubFormIndex = (subFormName: any, baseIndex: any) => {
          if (subFormName === "subForm-1") { return baseIndex; }
          if (subFormName === "subForm-3") { return subForm3Index; }
          return baseIndex - (paramsData.subForm_1?.length || 0);
        };

        const processedFields = ress.fields.map((data) => {
          const obj = { ...data };

          if (obj?.subForm?.length > 0) {
            const subFormList = data.subForm.map((subData: any) => {
              const subFormKey = data.name.replace("-", "_");
              const currentIndex = getSubFormIndex(data.name, subFormIndex);

              if (subData.type === "file") {
                return {
                  ...subData,
                  value: processFileField(subData.name, subFormKey, currentIndex)
                };
              }

              return {
                ...subData,
                value: paramsData[subFormKey]?.[currentIndex]?.[subData.name]
              };
            });

            if (data.name === "subForm-3") { subForm3Index++; }
            subFormIndex++;

            return { ...data, subForm: subFormList };
          }

          if (data.type === "file") {
            obj.value = processFileField(data.name);
          } else if (iframeData.apiCall && obj.type === "iframe") {
            obj.value = "completed";
          } else if (obj.type !== "iframe" && obj.type !== "file") {
            obj.value = paramsData[data.name];
          }

          if (data.name?.includes("firstName")) {
            localStorage.setItem("clindFirstName", obj.value);
          }

          return obj;
        });

        return { ...ress, fields: processedFields };
      });
      // console.log("sendData", sendData);
      let firstNameField = sendData.flatMap(forms => forms?.fields?.filter(ress => ress?.firstName === true));
      let lastNameField = sendData.flatMap(forms => forms?.fields?.filter(ress => ress?.lastName === true));
      let candidateName = (firstNameField[0]?.value ? firstNameField[0]?.value : "") + " " + (lastNameField[0]?.value ? lastNameField[0]?.value : "");
      if (candidateName.trim() !== "") {
        localStorage.setItem("newCandidateName", candidateName);
      } else {
        localStorage.setItem("newCandidateName", "");
      }

      submitCandidateData(sendData);
    }
  }, [fileUploadValue]);

  const fileUploadApiCall = (params: any) => {
    const checkAndSplit = params?.filter(
      (ress: any) => ress?.file instanceof File
    );
    const findPDFLabel = (fileId: any, formObject: any) => {
      let fileIdString = fileId.toString();
      let fileName = fileIdString.split(".").pop();
      let subformName = fileIdString.substring(0, fileIdString.indexOf("_"));
      let subformIndex = fileIdString.substring(fileIdString.indexOf("_") + 1, fileIdString.indexOf("_") + 2);  //Numeric identifier for field set, ie., different PDF labels      
      let subformFinalIndexArrayPointer = fileIdString.substring(fileIdString.indexOf(".") + 1, fileIdString.indexOf(".") + 2);
      let subformFinalIndex: any, labelList: any, subformLocation: any;
      if (subformName.length > 0) {
        // has subforms
        subformFinalIndex = formObject.filter((f: {}) => Object.keys(f).find((e) => e === subformName));
        subformLocation = subformFinalIndex.find((e: { name: string; }) => e.name === ("subForm-" + subformIndex)); //Finds the subform under the key: name which has the string "subForm"
        //get pdf label after finding file name attached to subform
        return subformLocation.subForm?.find((o: { name: any; }) => o.name === fileName).pdfLabel;
      }
      else {
        //no subforms
        labelList = formObject.filter((f: {}) => Object.keys(f).find((e) => e === "pdfLabel"));
        return formObject.find((f: { name: any; }) => f.name === fileId).pdfLabel;
      }
    };
    if (checkAndSplit.length > 0) {
      apiIndex = 0;
      fileValue = 100 / checkAndSplit.length;
      setSaveModel(true);
      const activeFormData: any = updateFormData.filter((ress) => ress?.active);
      const obj = { ...activeFormData[0] };
      const pathParamObj: any = {};
      pathParamObj["clientId"] = sessionStorage.getItem("clientId");
      pathParamObj["domainWithHttp"] = domainWithHttp;
      const filesSubmit = async () => {
        const fData = new FormData();
        fData.append("pdfLabel", findPDFLabel(checkAndSplit[apiIndex]?.fieldId, obj?.fields));
        fData.append("formLabel", obj["label"]);
        fData.append("clientId", obj["clientId"]);
        fData.append("candidateId", obj["candidateId"]);
        fData.append("formId", obj["formId"]);
        fData.append("fieldId", checkAndSplit[apiIndex]?.fieldId);
        fData.append("files", checkAndSplit[apiIndex]?.file);
        const response: any = await apiPost(
          endPoint.createCandidateDataDocuments,
          fData,
          pathParamObj
        );

        if (handleExpiredLink(response)) {
          setSaveModel(false);
          return;
        }

        if (response.status === 200) {
          const obj: any = {};
          obj["file"] = {
            fieldId: response?.data?.data?.fieldId,
            url: response?.data?.data?.url[0],
            name: response?.data?.data?.fileName,
          };
          obj["name"] = response?.data?.data?.fileName;
          obj["newUrl"] = true;
          setUplaodFileUrl((prs: any) => [...prs, obj]);
          setFileUploadValue((prevValue) => prevValue + fileValue);
          apiIndex++;
          if (checkAndSplit.length > apiIndex) {
            filesSubmit();
          }
        }
      };
      if (checkAndSplit?.length > 0) {
        filesSubmit();
      }
    } else {
      setFileUploadValue(100);
    }
    return;
  };

  const removeJsonFieldValue = (params: any) => {
    return {
      ...params,
      subForm: params.subForm.map((ress: any) => {
        return {
          ...ress,
          value: "",
        };
      }),
    };
  };

  /**
   * Check if the current active TFN / Super / Dynamic FLK form has any value changes
   * compared to its initial state. 
   * If changes are detected:
   * - It marks the form as changed (sets relevant flags)
   * - It resets all signing URLs and signature states (forcing the user to re-sign the form).
   */
  const checkIsFormValueChanged = (initialvalue: any, isDynamicFlkIframe: boolean = false) => {

    // Find currently active form (TFN / Super / Dynamic FLK) from the updateFormData array.
    const activeForms = updateFormData.filter(
      (ress) =>
        ress.active === true &&
        (flkState.type === "TFN" ||
          flkState.type === "SUPER" ||
          flkState.type === "DYNAMIC")
    );

    const activeForm: any = activeForms?.[0];

    if (!activeForm && !isDynamicFlkIframe) { return; }

    // Determine which page/form index is currently active (fallback to 0 if not found)
    const currentActivePage = activeForm?.index ?? 0;
    const formData = formRef.current[currentActivePage];

    let hasChangesDetected = false;

    // Loop through every field key in initialValues and compare with formData.values for changes.
    Object.keys(formData?.initialValues).map((ress) => {
      const initial = formData.initialValues[ress];
      const current = formData.values[ress];
      // If the field value is an array (e.g., multi-files, checkbox group, subform)
      if (Array.isArray(initial)) {
        if (initial.length !== current.length) {
          hasChangesDetected = true;
          return true;
        }
        // deep compare each element
        for (let i = 0; i < initial.length; i++) {
          const a = initial[i];
          const b = current[i];

          // JSON stringify is reliable here because your objects are stable
          if (JSON.stringify(a) !== JSON.stringify(b)) {
            hasChangesDetected = true;
            break;
          }
        }
        return true;
      }
      // ------ CASE 2: SIMPLE FIELD mismatch
      if (initial !== current) {
        hasChangesDetected = true;
        return true;
      }
      return false;
    });

    // ------------------------------
    // UPDATE flkState ONLY ONCE (React-safe)
    // ------------------------------
    // console.log("hasChangesDetected", hasChangesDetected);
    if (hasChangesDetected) {
      setFlkState((prev) => ({
        ...prev,
        hasChanges: true,
        signingUrl: "",   // core behavior preserved
        signedUrl: "",
        isSigned: false,
      }));
    }
  };

  // everthing from below is sorted for tfn,super.. temp comment
  const fileUploadData = async () => {
    setSveAndExitModel(false);
    const updateNewSubForm = updateFormData.map((ress, i) => {

      if ((changeParams && changeParams?.prsIndex === i) || ress.active) {
        const paramsData = formRef?.current[i]?.values;
        const getSubFormFromList1 = ress.fields.filter(
          (ress) => ress?.subForm && ress.name === "subForm-1"
        );
        const getSubFormFromList2 = ress.fields.filter(
          (ress) => ress?.subForm && ress.name === "subForm-2"
        );
        const getSubFormFromList3 = ress.fields.filter(
          (ress) => ress?.subForm && ress.name === "subForm-3"
        );
        const notGetSubFormFromList = ress.fields.filter(
          (ress) => !ress.subForm
        );
        const field: any = [];
        ress.fields.forEach((element: any) => {
          if (element.name !== "subForm-1" && element.name !== "subForm-2" && element.name !== "subForm-3") {
            const obj = { ...element };
            obj.value = "";
            field.push(element);
          } else {
            if (element.name === "subForm-1" && element.status) {
              paramsData.subForm_1.forEach((xx: any, i: number) => {
                const updatedObject = {
                  ...getSubFormFromList1[0],
                  status: i === 0 ? true : false,
                };
                field.push(removeJsonFieldValue(updatedObject));
              });
            } else if (element.name === "subForm-2" && element.status) {
              paramsData.subForm_2.forEach((xx: any, i: number) => {
                const updatedObject = {
                  ...getSubFormFromList2[0],
                  status: i === 0 ? true : false,
                };
                field.push(removeJsonFieldValue(updatedObject));
              });
            } else if (element.name === "subForm-3" && element.status) {
              paramsData.subForm_3.forEach((xx: any, i: number) => {
                const updatedObject = {
                  ...getSubFormFromList3[0],
                  status: i === 0 ? true : false,
                };
                field.push(removeJsonFieldValue(updatedObject));
              });
            }
          }
        });

        return {
          ...ress,
          fields: field,
        };
      }
      return ress;
    });
    setUpdateFormData(updateNewSubForm);
    const multiFileListConvertToSingle: any = [];
    setUplaodFileUrl([]);

    Object.keys(oldFile).forEach(async (ress) => {
      for (const fileObj of oldFile[ress]) {
        if (fileObj instanceof File) {
          multiFileListConvertToSingle.push({
            file: fileObj,
            name: fileObj.name,
            fieldId: ress,
          });
        } else {
          multiFileListConvertToSingle.push({
            file: fileObj.file,
            name: fileObj.name,
            fieldId: ress,
          });
        }
      }
    });
    if (multiFileListConvertToSingle.length > 0) {
      fileUploadApiCall(multiFileListConvertToSingle);
    } else {
      setFileUploadValue(100);
    }
    if (getFilesForDeletion?.length > 0) {
      deleteFilesFromServer();
    }
  };

  const saveModelClose = () => {
    setCountControl((prs) => {
      return {
        ...prs,
        saveModel: false,
        saveDraftTest: false,
      };
    });
  };
  const saveAndEditTime = (formIndex: any) => {
    setTimeout(() => {
      const paramsData = formRef.current[formIndex].errors;
      const errorData: any = Object.values(paramsData);
      if (errorData?.length > 0) {
        setSveAndExitModel(false);
        sessionStorage.setItem("navigateTo", (formIndex + 1).toString());
        return;
      }
    }, 1000);
    formstatus = "draft";
  };


  const saveAndEdit = () => {
    formstatusTwo = true;
    const prsForm: any = updateFormData.filter((ress: any) => ress.active);
    if (
      candidateData.finalStep === null ||
      prsForm[0]["index"] + 1 === Number(candidateData.finalStep)
    ) {

      fileUploadData();
      formstatus = "draft";
      setCountControl((prs) => {
        return {
          ...prs,
          saveModel: false,
          fileUplaod: false,
        };
      });
      setSveAndExitModel(false);
      setSaveToExitModel(false);
    } else {
      fileUploadData();
      setCountControl((prs) => {
        return {
          ...prs,
          saveModel: false,
          fileUplaod: false,
        };
      });
    }
  };

  const removeCurrentData = () => {
    const params: any = changeParams.params;
    if (
      changeParams?.index !== null &&
      candidateData?.finalStep >= changeParams?.index
    ) {
      const modifideFormData = updateFormData.map((data: any, k) => {
        const obj = { ...data };
        obj.active = false;
        if (params?.formId === data.formId) {
          obj.active = true;
          obj.currentPage = true;
          obj.currentPageStyle = "current-page";
        } else {
          if (candidateData?.finalStep > k + 1) {
            obj.completedPage = true;
            obj.currentPageStyle = "current-page";
            obj.currentPage = false;
          } else {

            obj.completedPage = false;
            obj.currentPageStyle = "null";
            obj.currentPage = false;
          }
        }
        if (params?.index === k) {
          return {
            ...obj,
            indata: params.indata,
          };
        } else {
          return obj;
        }
      });
      setUpdateFormData(modifideFormData);
      setSveAndExitModel(false);
    }
  };

  // When you click a step on the timeline or move between forms
  const getCurrentPage = (params: any, i: number) => {
    if (flkState.signingUrl?.length > 0) {
      toast("Please sign the document before moving to next page.", {
        type: "error",
        autoClose: 50000,
      });
      return;
    }
    setFlkState(prev => ({
      ...prev,
      signingUrl: "",
      signedUrl: "",
      isSigned: false,
      hasChanges: false,
    }));

    setIsLastPage(updateFormData.length === i);

    setSveAndExitModel(false);
    setSaveToExitModel(true);

    // --- Identify active form ---
    const activeForm: any = updateFormData.find((f) => f.active);
    const currentActivePage = activeForm?.index ?? 0;
    const formData = formRef.current[currentActivePage];
    // console.log("updateFormData", updateFormData);
    // --- Update theme classes for TFN / Super / Dynamic ---
    applyThemeFromFormData(activeForm);
    // --- Show the active form section (visibility control) ---
    if (params.isTFNForm || params.isSuperForm || params.flk_config?.isDynamicFlkForm) {
      document
        .getElementById(`personal-details-${params.index}`)
        ?.classList.replace("d-none", "d-flex");
    }

    changeParams = {
      params: params,
      index: i,
      prsIndexValues: formData,
      prsIndex: currentActivePage,
    };
    sessionStorage.setItem("navigateTo", i.toString());
    setDataIsUpdated(false);

    // compare each field to detect dirty state
    const checkingDataUpdate = Object.keys(formData?.initialValues).map(
      (ress) => {
        if (Array.isArray(formData.initialValues[ress])) {
          if (
            formData.initialValues[ress].length !== formData.values[ress].length
          ) {
            setDataIsUpdated(true);
            return true;
          } else {
            let hasMismatch = false;
            formData.initialValues[ress].forEach((item: any, i: number) => {
              if (item.name !== formData.values[ress][i]?.name) {
                setDataIsUpdated(true);
                hasMismatch = true;
              } else {
                Object.keys(item).forEach((xx) => {
                  if (
                    formData.initialValues[ress][i][xx] !==
                    formData.values[ress][i][xx]
                  ) {
                    hasMismatch = true;
                    setDataIsUpdated(true);
                  }
                });
              }
            });
            return hasMismatch;
          }
        } else if (formData.initialValues[ress] !== formData.values[ress]) {
          setDataIsUpdated(true);
          return true;
        }
        return null;
      }
    );

    const trueValues = checkingDataUpdate.some(
      (element, k) => element === true
    );
    let newActivePage = params?.index;

    if (newActivePage) { // added to show two form in single page when navigating via timeline

      if (updateFormData[newActivePage]) {
        if (updateFormData && updateFormData[newActivePage]) {
          updateFormData[newActivePage].active = true;
          //commented because of error [cannot active undefined]
          // updateFormData[i].active = false;
        }
        updateFormData[newActivePage].currentPage = true;
      }
      setUpdateFormData(updateFormData);
    }

    if (trueValues) {
      setSveAndExitModel(true);
    } else {
      removeCurrentData();
    }
  };

  const removeEditData = () => {
    navigate(0);
  };
  const checkWithFormStatus = () => {
    formstatus = "draft";

    const currentForm: any = updateFormData.find(
      (ress: any) => ress.index === changeParams.prsIndex
    );

    if (!currentForm) { return; }

    const currentIndex = currentForm.index;
    const submitBtn = document.getElementById(`submitBtn_${currentIndex}`);
    const isFinalStep = currentIndex + 1 === Number(candidateData.finalStep);

    if (isFinalStep) {
      checkTimeline = "cheking";
      updateValudatesetFormstatus("draft");

      submitBtn?.click();

      setCountControl((prs) => ({
        ...prs,
        timelineUpdate: true,
      }));
      saveAndEditTime(currentIndex);
    } else {
      checkTimeline = "";

      submitBtn?.click();

      setSveAndExitModel(false);
      sessionStorage.setItem("navigateTo", (currentIndex + 1).toString());
    }
    formstatusTwo = true;
  };
  const modelHeader = () => {
    return (
      <>
        <Modal.Header>
          <div>File upload</div>
        </Modal.Header>
      </>
    );
  };

  const modelBody = () => {
    return (
      <>
        <Modal.Body>
          <ProgressBar
            now={Math.round(fileUploadValue)}
            animated
            label={`${Math.round(fileUploadValue)}%`}
          />
          <div className="file-name-list">
            <ul className="list-group list-group-flush">
              {uploadFileUrl.map((ress: any) => {
                return (
                  <React.Fragment key={ress.name}>
                    {ress.newUrl ? (
                      <li
                        className="list-group-item px-0 d-flex justify-content-between align-items-start"
                      >
                        <div className="ms-2 me-auto">{ress.file.name}</div>
                        <span className="">
                          <div className="upload-file-list-name">
                            <i className="pi pi-check"></i>
                          </div>
                        </span>
                      </li>
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                );
              })}
            </ul>
          </div>
        </Modal.Body>
      </>
    );
  };

  const closeModel = () => {
    setCountControl((prs) => {
      return {
        ...prs,
        show: false,
      };
    });
  };
  const saveModelBody = () => {
    return (
      <>
        {!countControl.saveDraftTest ? (
          <>
            <Modal.Body className="p-3">
              <div className="d-flex">
                <div>
                  <h3 className="heading-3">
                    Are you sure you want to save and exit?
                  </h3>
                  <p className="save-para mb-0">
                    You will be able to return to finish this form at any time before the due date via the unique link in your email.
                  </p>
                </div>
                <div>
                  <div>
                    <i
                      role="button"
                      onClick={() => saveModelClose()}
                      className="pi pi-times"
                    ></i>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="p-3">
              <div className="text-end">
                <Button
                  label={"No, Continue Onboarding"}
                  onClick={() => {
                    saveModelClose();
                  }}
                  clasName="btn save-close-button"
                />
                <Button
                  label={
                    <>
                      <div className="d-flex">
                        <div className="yes-save-div">
                          <i className="pi pi-check"></i>
                        </div>
                        <span className="ms-2">Yes, Save & Complete Later</span>
                      </div>
                    </>
                  }
                  onClick={() => {
                    saveAndEdit();
                  }}
                  clasName="btn btn-primary ms-3"
                />
              </div>
            </Modal.Footer>
          </>
        ) : (
          <>
            <Modal.Body className="p-3">
              <div className="d-flex  justify-content-between">
                <div>
                  <h3 className="success-text d-flex">
                    <div className="bg-round">
                      <i className="pi pi-check"></i>
                    </div>
                    <span className="ps-2">
                      Your form has been saved successfully
                    </span>
                  </h3>
                  <p className="save-para-1 mb-0">
                    You may now close this window.
                  </p>
                </div>
                <div>
                  <div>
                    <i
                      role="button"
                      onClick={() => saveModelClose()}
                      className="pi pi-times"
                    ></i>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </>
        )}
      </>
    );
  };

  const confirmMass = () => {
    return (
      <>
        <Modal.Body className="p-3">
          <div className="d-flex justify-content-between">
            <div>
              <h3 className="heading-3">
                Are you sure you want to save existing data?
              </h3>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="p-3">
          <div className="text-center w-100">
            <Button
              label={"No"}
              onClick={() => {
                removeEditData();
              }}
              clasName="btn save-close-button"
            />
            <Button
              label={
                <>
                  <div className="d-flex">
                    <div className="yes-save-div">
                      <i className="pi pi-check"></i>
                    </div>{" "}
                    <span className="ms-2">Yes</span>
                  </div>
                </>
              }
              onClick={() => checkWithFormStatus()}
              clasName="btn btn-primary ms-3"
            />
          </div>
        </Modal.Footer>
      </>
    );
  };

  const removeFile = (index: any, filename: any, name: any, formik: any, fileItem?: any) => {
    const checkFieldId = name.split(".");
    const removeFileInStore: any[] = [];
    //initial call to delete file from server
    if (fileItem?.file?.url) {
      setFilesForDeletion((files: any) => [...files, fileItem?.file?.url]);
    }
    //remove locally
    if (checkFieldId.length === 3) {
      oldFile[name]?.forEach((data: any) => {
        if (data.name !== filename) {
          removeFileInStore.push(data);
        }
      });
      oldFile[name] = removeFileInStore;
      formik?.setFieldValue(name, removeFileInStore);
    } else {
      oldFile[name]?.forEach((data: any) => {
        if (data.name !== filename) {
          removeFileInStore.push(data);
        }
      });
      // oldFile[name] = removeFileInStore;
      const updateFile = { ...oldFile };
      updateFile[name] = removeFileInStore;
      updateOldFile(updateFile);
      formik?.setFieldValue(name, removeFileInStore);
    }
  };

  const base64StringToBlob = (base64String: any) => {
    const byteCharacters = atob(base64String);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: "application/octet-stream" });
  };
  const downloadFile = async (params: any) => {
    const obj: any = {};
    const pathParamObj: any = {};
    obj["url"] = params?.file?.url;
    pathParamObj["clientId"] = sessionStorage.getItem("clientId");
    pathParamObj["domainWithHttp"] = domainWithHttp;
    const responce = await apiPost(endPoint.download, obj, pathParamObj);
    if (responce.status === 200) {
      const blob = base64StringToBlob(responce?.data?.data);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = params?.file?.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  };
  const removeFileControl = (formik: any, data: any, index: number) => {
    return (
      <>
        <ol className="document-list-parent">
          {formik.values[data.name]?.map((item: any, i: number) => {
            return (
              <React.Fragment key={i}>
                <li
                  className="document-list mb-3 cust-document-list"
                >
                  <span className="file-name">
                    <Image src={DocIcon} />
                    {item instanceof File ? item.name : item.name}
                  </span>
                  <span role="button" className="ml-auto close-icon">
                    <i
                      onClick={() =>
                        removeFile(i, item.name, data.name, formik, item)
                      }
                      className="pi pi-times"
                    ></i>
                  </span>
                  {/* formik?.setFieldValue(data.name, removeFile(i, item.name, data.name, formik)) */}

                  {item instanceof File ? (
                    ""
                  ) : (
                    <i
                      className="pi pi-download me-3 d-none"
                      onClick={() => downloadFile(item)}
                    ></i>
                  )}
                  {formik.submitCount !== 0 &&
                    formik.errors &&
                    formik.errors[data.name] &&
                    Array.isArray(formik.errors[data.name]) ? (
                    <>
                      <span className="error-massage">
                        {
                          formik.errors[data.name]
                            ?.filter(
                              (data: any) =>
                                typeof data === "string" &&
                                data.split("_+_")[0] === item.name
                            )[0]
                            ?.split("_+_")[1]?.split("||")[0]
                        }
                      </span>
                    </>
                  ) : (
                    ""
                  )}

                </li>
              </React.Fragment>
            );
          })}
        </ol>
      </>
    );
  };

  useEffect(() => {
    if (iframeData.apiCall) {
      const obj: any = {};
      const pathParamObj: any = {};
      const controlEsign = updateFormData.filter((data: any) => data.active);
      obj["candidateId"] = controlEsign[0]?.candidateId;
      obj["clientId"] = controlEsign[0]?.clientId;
      obj["agreementId"] = controlEsign[0]?.fields.filter(
        (tt) => tt.type === "iframe"
      )[0]?.agreementId;
      pathParamObj["clientId"] = sessionStorage.getItem("clientId");
      pathParamObj["domainWithHttp"] = domainWithHttp;
      const sineData = async () => {
        dispatch<any>(loderControl());
        const response = await apiPost(endPoint.agreement, obj, pathParamObj);
        if (response.status === 200) {
          formstatus = "draft";
          fileUploadData();
        }
      };
      sineData();
    }
  }, [iframeData]);

  const handleIframeMessage = async (event: MessageEvent<any>) => {
    if (typeof event?.data === "string") {
      try {
        const jsonObject = JSON.parse(event?.data);
        if (jsonObject?.type === "ESIGN") {
          setIframeData((prs: any) => {
            return {
              ...prs,
              apiCall: true,
              sigcontrol: true,
            };
          });
        }
      } catch (error) {
        // Ignore non-JSON messages from iframe or other sources
        console.debug("Received non-JSON iframe message:", event?.data);
      }
    }
  };
  useEffect(() => {
    window.addEventListener("message", handleIframeMessage);
    return () => {
      window.removeEventListener("message", handleIframeMessage);
    };
  }, []);

  const addNewChildForm = (params: any) => {
    const obj: any = {};
    Object.keys(params).forEach((ress) => {
      obj[ress] = "";
    });
    return obj;
  };
  const removeSubFormIndex = (params: any, index: number, formName: string) => {
    const obj: any = {};
    Object.keys(params[0]).forEach((ress) => {
      const removeFileData = Object.keys(oldFile).filter(
        (data) =>
          `${formName}.${index}.${data}` === `${formName}.${index}.${ress}`
      );
      delete oldFile[`${formName}.${index}.${removeFileData}`];
      Object.keys(oldFile).forEach((ress) => {
        const sumformKey = ress?.split(".");
        if (sumformKey.length === 3 && sumformKey[0] === formName) {
          if (parseInt(sumformKey[1]) === index) {
            delete oldFile[
              sumformKey[0] + "." + sumformKey[1] + "." + sumformKey[2]
            ];
          }
        }
      });
    });
    updateOldFile(oldFile);
    return index;
  };
  const subForm_2 = (formik: any, htmlForm: any) => {
    const getChildFormJson = htmlForm.filter(
      (data: any) => data.subForm && data.name === "subForm-2"
    );
    return (
      <>
        {getChildFormJson.length > 0 &&
          formik?.values?.subForm_2?.length > 0 ? (
          <>
            <FieldArray name="subForm_2">
              {({ insert, remove, push, form }) => (
                <>
                  {formik?.values?.subForm_2?.map(
                    (item: any, subIndex: number) => {
                      return (
                        <React.Fragment key={subIndex}>
                          <hr className="hrline" />

                          <div className="row cust-cont-row">
                            {getChildFormJson[0].subForm.map(
                              (setChildField: any, childIndex: number) => {
                                return (
                                  <div key={childIndex} className={setChildField?.className}>
                                    <div className="row">
                                      <div
                                        className={`${setChildField?.lableClass}`}
                                      >
                                        <Label
                                          name={setChildField?.label}
                                          className="form-label"
                                          label={setChildField?.label}
                                          subLabel={setChildField?.subLabel}
                                          required={setChildField?.required}
                                        />
                                      </div>
                                      <small className="form-description">
                                        {setChildField?.description}
                                      </small>

                                      <div
                                        className={`${setChildField?.inputClass}`}
                                      >
                                        {setChildField?.type === "date" ? (
                                          <>
                                            <FormikControl
                                              control="date"
                                              type={setChildField?.type}
                                              name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                              className={"form-control"}
                                              allData={setChildField}
                                              dateFormat={
                                                setChildField?.dateFormat
                                              }
                                            />
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        {setChildField?.type === "file" ? (
                                          <>
                                            <FormikControl
                                              control="file"
                                              name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                              className={"form-control"}
                                              option={setChildField?.values}
                                              allData={setChildField}
                                            />
                                            <>
                                              <div className="col-12">
                                                {formik?.values?.subForm_2[
                                                  subIndex
                                                ][setChildField.name]
                                                  ?.length > 0 ? (
                                                  <>
                                                    <ol className="document-list-parent">
                                                      {Array.isArray(
                                                        formik.values
                                                          ?.subForm_2[
                                                        subIndex
                                                        ][setChildField?.name]
                                                      )
                                                        ? formik.values?.subForm_2[
                                                          subIndex
                                                        ][
                                                          setChildField
                                                            ?.name
                                                        ].map(
                                                          (
                                                            ress: any,
                                                            i: number
                                                          ) => {
                                                            return (
                                                              <React.Fragment key={i}>
                                                                {/* <div className={item.UrlClass}> */}
                                                                <li
                                                                  className="document-list mb-3 cust-document-list"
                                                                >
                                                                  <span className="file-name">
                                                                    <Image src={DocIcon} />
                                                                    {ress instanceof
                                                                      File
                                                                      ? ress.name
                                                                      : ress
                                                                        ?.file
                                                                        ?.name}
                                                                  </span>

                                                                  <span role="button" className="ml-auto close-icon">
                                                                    <i
                                                                      className="pi pi-times"
                                                                      onClick={() =>
                                                                        removeFile(
                                                                          i,
                                                                          ress.name,
                                                                          `subForm_2.${subIndex}.${setChildField.name}`,
                                                                          formik,
                                                                          ress
                                                                        )
                                                                      }
                                                                    ></i>
                                                                  </span>

                                                                  {ress instanceof
                                                                    File ? (
                                                                    ""
                                                                  ) : (
                                                                    <i
                                                                      onClick={() =>
                                                                        downloadFile(
                                                                          ress
                                                                        )
                                                                      }
                                                                      className="pi pi-download me-3 d-none"
                                                                    ></i>
                                                                  )}
                                                                  {/* {formik.submitCount !==
                                                                      0 &&
                                                                      formik
                                                                        .errors
                                                                        ?.subForm_2 &&
                                                                      formik
                                                                        .errors
                                                                        ?.subForm_2[
                                                                      subIndex
                                                                      ] &&
                                                                      Array.isArray(
                                                                        formik
                                                                          .errors
                                                                          ?.subForm_2[
                                                                        subIndex
                                                                        ][
                                                                        setChildField
                                                                          ?.name
                                                                        ]
                                                                      ) ? (
                                                                      <>
                                                                        {formik.errors?.subForm_2[
                                                                          subIndex
                                                                        ][
                                                                          setChildField
                                                                            ?.name
                                                                        ]?.filter(
                                                                          (
                                                                            data: string
                                                                          ) =>
                                                                            data ===
                                                                            (ress instanceof
                                                                              File
                                                                              ? ress.name
                                                                              : ress
                                                                                ?.file
                                                                                ?.name)
                                                                        )
                                                                          ?.length ===
                                                                          1 ? (
                                                                          <span className="error-massage me-5">
                                                                            File
                                                                            type
                                                                            is
                                                                            not
                                                                            allowed
                                                                          </span>
                                                                        ) : (
                                                                          ""
                                                                        )}
                                                                      </>
                                                                    ) : (
                                                                      ""
                                                                    )} */}
                                                                  <span className="error-massage">
                                                                    {
                                                                      formik?.submitCount !== 0 &&
                                                                      formik?.errors &&
                                                                      formik?.errors?.subForm_2 &&
                                                                      Array.isArray(formik?.errors?.subForm_2) &&  // Check if subForm_1 is an array
                                                                      formik?.errors?.subForm_2.length > 0 &&
                                                                      formik?.errors?.subForm_2[subIndex] &&
                                                                      formik?.errors?.subForm_2[subIndex][setChildField?.name] &&
                                                                      Array.isArray(formik?.errors?.subForm_2[subIndex][setChildField?.name]) &&  // Check if the nested array is an array
                                                                      formik?.errors?.subForm_2[subIndex][setChildField?.name]?.length > 0 &&
                                                                      Array.isArray(formik?.errors?.subForm_2[subIndex][setChildField?.name]) &&  // Check if the nested array is an array
                                                                      formik?.errors?.subForm_2[subIndex][setChildField?.name]?.filter((data: any) => typeof data === "string" && data.split("_+_")[0] === ress.name)?.[0]?.split("_+_")[1]?.split("||")?.[0]
                                                                    }
                                                                  </span>
                                                                </li>
                                                              </React.Fragment>
                                                            );
                                                          }
                                                        )
                                                        : null}
                                                    </ol>
                                                  </>
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                            </>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        {setChildField.type ===
                                          "checkbox-group" ||
                                          setChildField.type === "checkbox" ? (
                                          <>
                                            <FormikControl
                                              control="checkbox"
                                              name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                              className={"form-control"}
                                              option={setChildField?.values}
                                              allData={setChildField}
                                              formik={formik}
                                            />
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        {setChildField?.type ===
                                          "radio-group" ? (
                                          <>
                                            <FormikControl
                                              control="radio"
                                              name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                              className={"form-control"}
                                              option={setChildField?.values}
                                              allData={setChildField}
                                            />
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        {setChildField?.type === "html" ? (
                                          <>
                                            <div
                                              className="com-html-text"
                                              dangerouslySetInnerHTML={{
                                                __html: setChildField?.value,
                                              }}
                                            ></div>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        {setChildField?.type === "select" ? (
                                          <>
                                            <FormikControl
                                              control="select"
                                              type={setChildField?.type}
                                              name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                              className={"form-select"}
                                              allData={setChildField}
                                            />
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        {setChildField?.type === "multiSelect" ? (
                                          <>
                                            <FormikControl
                                              control="multiSelect"
                                              type={setChildField?.type}
                                              name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                              className={"form-select"}
                                              allData={setChildField}
                                              multi={true}
                                            />
                                          </>
                                        ) : (
                                          ""
                                        )}

                                        {setChildField.type === "text" ||
                                          setChildField.type === "number" || setChildField.type === "split-input" ? (
                                          <>
                                            <FormikControl
                                              control="input"
                                              type={setChildField?.type}
                                              name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                              className={"form-control"}
                                              allData={setChildField}
                                            />
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        {setChildField.type === "textarea" ? (
                                          <>
                                            <FormikControl
                                              control="textarea"
                                              type={setChildField?.type}
                                              name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                              className={"form-control"}
                                              allData={setChildField}
                                            />
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                      {formik?.values?.subForm_2?.length >
                                        1 ? (
                                        <>
                                          {setChildField?.addButton ? (
                                            <div
                                              className="btn-add-remove-section"
                                            >
                                              <Button
                                                clasName="btn btn-secondary add-subform-button cust-remove-button"
                                                type="button"
                                                onClick={() =>
                                                  remove(
                                                    removeSubFormIndex(
                                                      formik?.initialValues
                                                        ?.subForm_2,
                                                      subIndex,
                                                      "subForm_2"
                                                    )
                                                  )
                                                }
                                                label={
                                                  <>
                                                    <div className="d-flex align-items-center">
                                                      <Image
                                                        src={Bin}
                                                        clasName="me-2"
                                                      />{" "}
                                                      <div>
                                                        {
                                                          getChildFormJson[0]
                                                            ?.removeButtonLabel
                                                        }
                                                      </div>
                                                    </div>
                                                  </>
                                                }
                                              />
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </React.Fragment>
                      );
                    }
                  )}
                  {getChildFormJson[0]?.AddButtonCount > formik?.values?.subForm_2?.length ?
                    <div className="btn-add-remove-section">
                      <Button
                        position="left"
                        icon="pi pi-plus add-subform-icon"
                        label={getChildFormJson[0]?.AddButtonLabel}
                        type="button"
                        onClick={() =>
                          push(
                            addNewChildForm(formik?.initialValues?.subForm_2[0])
                          )
                        }
                        clasName="btn add-subform-button"
                      />
                    </div>
                    :
                    ""
                  }
                </>
              )}
            </FieldArray>
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  const subForm_1 = (formik: any, htmlForm: any) => {
    const getChildFormJson = htmlForm.filter(
      (data: any) => data.subForm && data.name === "subForm-1"
    );
    return (
      <>
        {getChildFormJson.length > 0 &&
          formik?.values?.subForm_1?.length > 0 ? (
          <>
            <FieldArray name="subForm_1">
              {({ insert, remove, push, form }) => (
                <>
                  {formik?.values?.subForm_1?.map(
                    (item: any, subIndex: number) => {
                      return (
                        <React.Fragment key={subIndex}>
                          <hr className="hrline" />
                          <div className="row cust-cont-row">
                            {getChildFormJson[0].subForm.map(
                              (setChildField: any, index: number) => {
                                return (
                                  <React.Fragment key={index}>
                                    {checkParentMatch(setChildField, formik.values?.subForm_1[subIndex]) ? (
                                      <div className={setChildField?.className}>
                                        <div className="row">
                                          <div
                                            className={`${setChildField?.lableClass}`}
                                          >
                                            <Label
                                              name={setChildField?.label}
                                              className={"form-label"}
                                              label={setChildField?.label}
                                              subLabel={setChildField?.subLabel}
                                              required={setChildField?.required}
                                            />
                                          </div>
                                          <small className="form-description">
                                            {setChildField?.description}
                                          </small>
                                          <div
                                            className={`${setChildField?.inputClass}`}
                                          >
                                            {setChildField?.type === "date" ? (
                                              <>
                                                {/* <Image src={DataIcon} /> */}
                                                <FormikControl
                                                  control="date"
                                                  type={setChildField?.type}
                                                  name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                  className={"form-control"}
                                                  allData={setChildField}
                                                  dateFormat={
                                                    setChildField?.dateFormat
                                                  }
                                                />
                                              </>
                                            ) : (
                                              ""
                                            )}
                                            {setChildField?.type === "file" ? (
                                              <>
                                                <FormikControl
                                                  control="file"
                                                  name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                  className={"form-control"}
                                                  option={setChildField?.values}
                                                  allData={setChildField}
                                                />
                                                <>
                                                  <div className="col-12">
                                                    {formik?.values?.subForm_1[
                                                      subIndex
                                                    ][setChildField.name]
                                                      ?.length > 0 ? (
                                                      <>
                                                        <ol className="document-list-parent">
                                                          {Array.isArray(
                                                            formik.values
                                                              ?.subForm_1[
                                                            subIndex
                                                            ][setChildField?.name]
                                                          )
                                                            ? formik.values?.subForm_1[
                                                              subIndex
                                                            ][
                                                              setChildField
                                                                ?.name
                                                            ].map(
                                                              (
                                                                ress: any,
                                                                i: number
                                                              ) => {


                                                                return (
                                                                  <>
                                                                    {/* <div className={item.UrlClass}> */}
                                                                    <li
                                                                      key={i}
                                                                      className="document-list mb-3 cust-document-list"
                                                                    >
                                                                      <span className="file-name">
                                                                        <Image src={DocIcon} />
                                                                        {ress instanceof
                                                                          File
                                                                          ? ress.name
                                                                          : ress
                                                                            ?.file
                                                                            ?.name}
                                                                      </span>
                                                                      <span role="button" className="ml-auto close-icon">
                                                                        <i
                                                                          className="pi pi-times"
                                                                          onClick={() =>
                                                                            removeFile(
                                                                              i,
                                                                              ress.name,
                                                                              `subForm_1.${subIndex}.${setChildField.name}`,
                                                                              formik,
                                                                              ress
                                                                            )
                                                                          }
                                                                        ></i>
                                                                      </span>

                                                                      {ress instanceof
                                                                        File ? (
                                                                        ""
                                                                      ) : (
                                                                        <i
                                                                          onClick={() =>
                                                                            downloadFile(
                                                                              ress
                                                                            )
                                                                          }
                                                                          className="pi pi-download me-3 d-none"
                                                                        ></i>
                                                                      )}
                                                                      <span className="error-massage">
                                                                        {
                                                                          formik?.submitCount !== 0 &&
                                                                          formik?.errors &&
                                                                          formik?.errors?.subForm_1 &&
                                                                          Array.isArray(formik?.errors?.subForm_1) &&  // Check if subForm_1 is an array
                                                                          formik?.errors?.subForm_1.length > 0 &&
                                                                          formik?.errors?.subForm_1[subIndex] &&
                                                                          formik?.errors?.subForm_1[subIndex][setChildField?.name] &&
                                                                          Array.isArray(formik?.errors?.subForm_1[subIndex][setChildField?.name]) &&  // Check if the nested array is an array
                                                                          formik?.errors?.subForm_1[subIndex][setChildField?.name]?.length > 0 &&
                                                                          Array.isArray(formik?.errors?.subForm_1[subIndex][setChildField?.name]) &&  // Check if the nested array is an array
                                                                          formik?.errors?.subForm_1[subIndex][setChildField?.name]?.filter((data: any) => typeof data === "string" && data.split("_+_")[0] === ress.name)?.[0]?.split("_+_")[1]?.split("||")?.[0]


                                                                        }

                                                                      </span>

                                                                      {/* <span>{formik?.error?.subForm_1}</span> */}
                                                                    </li>
                                                                    {/* </div> */}
                                                                  </>
                                                                );
                                                              }
                                                            )
                                                            : null}
                                                        </ol>
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </div>
                                                </>
                                              </>
                                            ) : (
                                              ""
                                            )}
                                            {setChildField.type ===
                                              "checkbox-group" ||
                                              setChildField.type === "checkbox" ? (
                                              <>
                                                <FormikControl
                                                  control="checkbox"
                                                  name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                  className={"form-control"}
                                                  option={setChildField?.values}
                                                  allData={setChildField}
                                                  formik={formik}
                                                />
                                              </>
                                            ) : (
                                              ""
                                            )}
                                            {setChildField?.type ===
                                              "radio-group" ? (
                                              <>
                                                <FormikControl
                                                  control="radio"
                                                  name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                  className={"form-control"}
                                                  option={setChildField?.values}
                                                  allData={setChildField}
                                                />
                                              </>
                                            ) : (
                                              ""
                                            )}
                                            {setChildField?.type === "html" ? (
                                              <>
                                                <div
                                                  className="com-html-text"
                                                  dangerouslySetInnerHTML={{
                                                    __html: setChildField?.value,
                                                  }}
                                                ></div>
                                              </>
                                            ) : (
                                              ""
                                            )}
                                            {setChildField?.type === "select" ? (
                                              <>
                                                <FormikControl
                                                  control="select"
                                                  type={setChildField?.type}
                                                  name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                  className={"form-select"}
                                                  allData={setChildField}
                                                />
                                              </>
                                            ) : (
                                              ""
                                            )}
                                            {setChildField?.type === "multiSelect" ? (
                                              <>
                                                <FormikControl
                                                  control="multiSelect"
                                                  type={setChildField?.type}
                                                  name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                                  className={"form-select"}
                                                  allData={setChildField}
                                                  multi={true}
                                                />
                                              </>
                                            ) : (
                                              ""
                                            )}

                                            {setChildField.type === "text" ||
                                              setChildField.type === "number" || setChildField.type === "split-input" ? (
                                              <>
                                                <FormikControl
                                                  control="input"
                                                  type={setChildField?.type}
                                                  name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                  className={"form-control"}
                                                  allData={setChildField}
                                                />
                                              </>
                                            ) : (
                                              ""
                                            )}
                                            {setChildField.type === "textarea" ? (
                                              <>
                                                <FormikControl
                                                  control="textarea"
                                                  type={setChildField?.type}
                                                  name={`subForm_1.${subIndex}.${setChildField?.name}`}
                                                  className={"form-control"}
                                                  allData={setChildField}
                                                />
                                              </>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                          {formik?.values?.subForm_1?.length >
                                            1 ? (
                                            <>
                                              {setChildField?.addButton ? (
                                                <div
                                                  className="btn-add-remove-section"
                                                >
                                                  <Button
                                                    clasName="btn add-subform-button cust-remove-button"
                                                    type="button"
                                                    onClick={() =>
                                                      remove(
                                                        removeSubFormIndex(
                                                          formik?.initialValues
                                                            ?.subForm_1,
                                                          subIndex,
                                                          "subForm_1"
                                                        )
                                                      )
                                                    }
                                                    label={
                                                      <>
                                                        <div className="d-flex align-items-center">
                                                          <Image
                                                            src={Bin}
                                                            clasName="me-2"
                                                          />{" "}
                                                          <div>
                                                            {
                                                              getChildFormJson[0]
                                                                ?.removeButtonLabel
                                                            }
                                                          </div>
                                                        </div>
                                                      </>
                                                    }
                                                  />
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    ) : (
                                      "")}
                                  </React.Fragment>
                                );
                              }
                            )}
                            {/* <div className="d-none">
                                <div className="text-center my-2">
                                    <Button id="subForm-1-addbutton" position="left" icon="pi pi-plus add-subform-icon" label={getChildFormJson[0]?.AddButtonLabel} type="button" onClick={() => push(addNewChildForm(formik?.initialValues?.subForm_1[0]))} clasName="btn btn-primary " />
                                </div>
                            </div> */}
                          </div>
                        </React.Fragment>
                      );
                    }
                  )}
                  {getChildFormJson[0]?.AddButtonCount > formik?.values?.subForm_1?.length ?
                    <div className="btn-add-remove-section">
                      <Button
                        id="subForm-1-addbutton"
                        position="left"
                        icon="pi pi-plus add-subform-icon"
                        label={getChildFormJson[0]?.AddButtonLabel}
                        type="button"
                        onClick={() =>
                          push(
                            addNewChildForm(formik?.initialValues?.subForm_1[0])
                          )
                        }
                        clasName="btn add-subform-button "
                      />
                    </div>
                    :
                    ""
                  }
                </>
              )}
            </FieldArray>
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  const subForm_3 = (formik: any, htmlForm: any) => {
    const getChildFormJson = htmlForm.filter(
      (data: any) => data.subForm && data.name === "subForm-3"
    );

    return (
      <>
        {getChildFormJson.length > 0 &&
          formik?.values?.subForm_3?.length > 0 ? (
          <>
            <FieldArray name="subForm_3">
              {({ insert, remove, push, form }) => (
                <>
                  {formik?.values?.subForm_3?.map(
                    (item: any, subIndex: number) => {
                      return (
                        <React.Fragment key={subIndex}>
                          <hr className="hrline" />
                          <div className="row cust-cont-row">
                            {getChildFormJson[0].subForm.map(
                              (setChildField: any, childIndex: number) => {
                                return (
                                  <React.Fragment key={childIndex}>
                                    <div className={setChildField?.className}>
                                      <div className="row">
                                        <div
                                          className={`${setChildField?.lableClass}`}
                                        >
                                          <Label
                                            name={setChildField?.label}
                                            className={"form-label"}
                                            label={setChildField?.label}
                                            subLabel={setChildField?.subLabel}
                                            required={setChildField?.required}
                                          />
                                        </div>
                                        <small className="form-description">
                                          {setChildField?.description}
                                        </small>
                                        <div
                                          className={`${setChildField?.inputClass}`}
                                        >
                                          {setChildField?.type === "date" ? (
                                            <>
                                              {/* <Image src={DataIcon} /> */}
                                              <FormikControl
                                                control="date"
                                                type={setChildField?.type}
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                allData={setChildField}
                                                dateFormat={
                                                  setChildField?.dateFormat
                                                }
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "file" ? (
                                            <>
                                              <FormikControl
                                                control="file"
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                option={setChildField?.values}
                                                allData={setChildField}
                                              />
                                              <>
                                                <div className="col-12">
                                                  {formik?.values?.subForm_3[
                                                    subIndex
                                                  ][setChildField.name]
                                                    ?.length > 0 ? (
                                                    <>
                                                      <ol className="document-list-parent">
                                                        {Array.isArray(
                                                          formik.values
                                                            ?.subForm_3[
                                                          subIndex
                                                          ][setChildField?.name]
                                                        )
                                                          ? formik.values?.subForm_3[
                                                            subIndex
                                                          ][
                                                            setChildField
                                                              ?.name
                                                          ].map(
                                                            (
                                                              ress: any,
                                                              i: number
                                                            ) => {


                                                              return (
                                                                <>
                                                                  {/* <div className={item.UrlClass}> */}
                                                                  <li
                                                                    key={i}
                                                                    className="document-list mb-3 cust-document-list"
                                                                  >
                                                                    <span className="file-name">
                                                                      <Image src={DocIcon} />
                                                                      {ress instanceof
                                                                        File
                                                                        ? ress.name
                                                                        : ress
                                                                          ?.file
                                                                          ?.name}
                                                                    </span>
                                                                    <span role="button" className="ml-auto close-icon">
                                                                      <i
                                                                        className="pi pi-times"
                                                                        onClick={() =>
                                                                          removeFile(
                                                                            i,
                                                                            ress.name,
                                                                            `subForm_3.${subIndex}.${setChildField.name}`,
                                                                            formik,
                                                                            ress
                                                                          )
                                                                        }
                                                                      ></i>
                                                                    </span>

                                                                    {ress instanceof
                                                                      File ? (
                                                                      ""
                                                                    ) : (
                                                                      <i
                                                                        onClick={() =>
                                                                          downloadFile(
                                                                            ress
                                                                          )
                                                                        }
                                                                        className="pi pi-download me-3 d-none"
                                                                      ></i>
                                                                    )}
                                                                    <span className="error-massage">
                                                                      {
                                                                        formik?.submitCount !== 0 &&
                                                                        formik?.errors &&
                                                                        formik?.errors?.subForm_3 &&
                                                                        Array.isArray(formik?.errors?.subForm_3) &&  // Check if subForm_1 is an array
                                                                        formik?.errors?.subForm_3.length > 0 &&
                                                                        formik?.errors?.subForm_3[subIndex] &&
                                                                        formik?.errors?.subForm_3[subIndex][setChildField?.name] &&
                                                                        Array.isArray(formik?.errors?.subForm_3[subIndex][setChildField?.name]) &&  // Check if the nested array is an array
                                                                        formik?.errors?.subForm_3[subIndex][setChildField?.name]?.length > 0 &&
                                                                        Array.isArray(formik?.errors?.subForm_3[subIndex][setChildField?.name]) &&  // Check if the nested array is an array
                                                                        formik?.errors?.subForm_3[subIndex][setChildField?.name]?.filter((data: any) => typeof data === "string" && data.split("_+_")[0] === ress.name)?.[0]?.split("_+_")[1]?.split("||")?.[0]


                                                                      }

                                                                    </span>


                                                                  </li>

                                                                </>
                                                              );
                                                            }
                                                          )
                                                          : null}
                                                      </ol>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                              </>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField.type ===
                                            "checkbox-group" ||
                                            setChildField.type === "checkbox" ? (
                                            <>
                                              <FormikControl
                                                control="checkbox"
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                option={setChildField?.values}
                                                allData={setChildField}
                                                formik={formik}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type ===
                                            "radio-group" ? (
                                            <>
                                              <FormikControl
                                                control="radio"
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                option={setChildField?.values}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "html" ? (
                                            <>
                                              <div
                                                className="com-html-text"
                                                dangerouslySetInnerHTML={{
                                                  __html: setChildField?.value,
                                                }}
                                              ></div>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "select" ? (
                                            <>
                                              <FormikControl
                                                control="select"
                                                type={setChildField?.type}
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-select"}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField?.type === "multiSelect" ? (
                                            <>
                                              <FormikControl
                                                control="multiSelect"
                                                type={setChildField?.type}
                                                name={`subForm_2.${subIndex}.${setChildField?.name}`}
                                                className={"form-select"}
                                                allData={setChildField}
                                                multi={true}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField.type === "text" ||
                                            setChildField.type === "number" || setChildField.type === "split-input" ? (
                                            <>
                                              <FormikControl
                                                control="input"
                                                type={setChildField?.type}
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {setChildField.type === "textarea" ? (
                                            <>
                                              <FormikControl
                                                control="textarea"
                                                type={setChildField?.type}
                                                name={`subForm_3.${subIndex}.${setChildField?.name}`}
                                                className={"form-control"}
                                                allData={setChildField}
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                        {formik?.values?.subForm_3?.length >
                                          1 ? (
                                          <>
                                            {setChildField?.addButton ? (
                                              <div
                                                className="btn-add-remove-section"
                                              >
                                                <Button
                                                  clasName="btn add-subform-button cust-remove-button"
                                                  type="button"
                                                  onClick={() =>
                                                    remove(
                                                      removeSubFormIndex(
                                                        formik?.initialValues
                                                          ?.subForm_3,
                                                        subIndex,
                                                        "subForm_3"
                                                      )
                                                    )
                                                  }
                                                  label={
                                                    <>
                                                      <div className="d-flex align-items-center">
                                                        <Image
                                                          src={Bin}
                                                          clasName="me-2"
                                                        />{" "}
                                                        <div>
                                                          {
                                                            getChildFormJson[0]
                                                              ?.removeButtonLabel
                                                          }
                                                        </div>
                                                      </div>
                                                    </>
                                                  }
                                                />
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </React.Fragment>
                                );
                              }
                            )}
                          </div>
                        </React.Fragment>
                      );
                    }
                  )}
                  {getChildFormJson[0]?.AddButtonCount > formik?.values?.subForm_3?.length ?
                    <div className="btn-add-remove-section">
                      <Button
                        id="subForm-3-addbutton"
                        position="left"
                        icon="pi pi-plus add-subform-icon"
                        label={getChildFormJson[0]?.AddButtonLabel}
                        type="button"
                        onClick={() =>
                          push(
                            addNewChildForm(formik?.initialValues?.subForm_3[0])
                          )
                        }
                        clasName="btn add-subform-button "
                      />
                    </div>
                    :
                    ""
                  }
                </>
              )}
            </FieldArray>
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  const inputTypeFile = (formik: any, data: any, i: number) => {
    return (
      <>
        <FormikControl
          control="file"
          name={data.name}
          className="form-control"
          option={data.values}
          allData={data}
          value={formik.values[data.name]}
          formikData={formik}
        />

        {formik.values[data.name]?.length > 0 && (
          <div className="col-12">
            {removeFileControl(formik, data, i)}
          </div>
        )}
      </>
    );
  };

  const errorControl = (data: any, formik: any) => {
    if (data?.name && formik?.values[data?.name]?.length > 0) {
      formik.setFieldValue(data?.name, []);
      oldFile[data.name] = [];
    }

    return "";
  };

  useEffect(() => {
    if (updateFormData?.length > 0) {
      const currentIndex: any = updateFormData.filter((ress) => ress?.currentPage);
      setTimeout(() => {
        sliderRef?.current?.slickGoTo(currentIndex[0]?.index);
      }, 800);
    }
  }, [updateFormData]);

  if (expiredLinkMessage) {
    return (
      <>
        <div>
          <Loader loading={loader} />
        </div>
        <div className="container">
          <div className="row justify-content-center align-item-center">
            <div className="col-md-7 col-lg-6">
              <div className="mt-5 pt-4">
                <div className="alert alert-danger text-center" role="alert">
                  <p className="mb-2">{expiredLinkMessage || "This link has been expired. Please contact administrator."}</p>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div>
        <Loader loading={loader} />
      </div>
      <div
        className="container-fluid pt-3 onboarding-shell"
        ref={ref}
        style={{ backgroundColor: "#FFFF", overflow: "hidden" }}
      >
        {screenShort.active ? (
          <>
            <div className="row onboarding-top-row">
              <div className="col-12 d-flex onboarding-timeline-col">
                <div className="onboarding-timeline-width">
                  <div className="compliance-timeline compliance-timeline-new">
                    <Button
                      onClick={() => {
                        checkTimeline = "";
                        updateValudatesetFormstatus("draft");
                        const prsForm: any = updateFormData.filter((ress: any) => ress.active);
                        document.getElementById(`submitBtn_${prsForm[0]["index"]}`)?.click();
                      }
                      }
                      icon="pi pi-clock"
                      position="left"
                      label={candidateData?.draftButtonText ? candidateData?.draftButtonText : "Save & Exit"}
                      clasName="btn btn-primary btn-top-head"
                    />
                    <div key={getOrientationChange.timeStamp} className={`slick-main-parent ${updateFormData?.length >= getScreenWidth.showCount ? "remove-start-line" : ""}`}>
                      <Slider {...settings} ref={sliderRef}>
                        {updateFormData?.map((ress: any, i: number) => {
                          return (
                            <div
                              key={i}
                              role={Number(candidateData?.finalStep) >= i + 1 ? "button" : "none"}
                              onClick={() =>
                                candidateData?.finalStep &&
                                Number(candidateData?.finalStep) >= i + 1 &&
                                getCurrentPage(ress, i + 1)
                              }
                              className={`slick-cont
                                ${updateFormData?.length === 1 ? "remove-all-index-line" : ""}
                                ${i === 0 ? "first-list" : ""}
                                ${i + 1 === updateFormData?.length ? "last-index" : ""}
                                ${ress?.completedPage && ress.currentPage ? "slick-cont-dot-active slick-cont-line-active" : ""}
                                ${ress?.completedPage && !ress?.currentPage ? "slick-cont slick-cont-dot-active slick-cont-line-active slick-cont-completed" : ""}
                                ${ress?.currentPage ? "completed slick-cont-dot-active slick-cont-half-line-active" : ""}
                                ${candidateData?.finalStep >= i + 1 ? "slick-cont-half-line-active" : ""}
                                ${slickStyleUpdate.currentPage === i ? "first-list" : slickStyleUpdate?.nextIndex === i ? "last-index" : ""}
                              `}
                            >
                              <div className="slick-cont-inner">
                                <h3 title={ress.label}>{ress.label}</h3>
                              </div>
                            </div>
                          );

                        })}
                      </Slider>
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </div>
            <div className="row onboarding-completion-row">
              <div className="col-12">
                <div className="onboarding-completion-width">
                  <div className="onboarding-completion-wrap onboarding-completion-strip">
                    <div className="completion-progress">
                      <div
                        className="barbg"
                        style={{ width: candidateData?.completionPercentage }}
                      ></div>
                    </div>
                    <div className="completion pt-1">
                      Completion:{" "}
                      <span className="fw-bold">
                        {candidateData?.completionPercentage}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </>
        ) : (
          // add msg to give more info
          <div className="row">
            <div className="col-12">
              <div className="alert alert-info" role="alert">
                {candidateData?.screenShortMessage ? candidateData?.screenShortMessage : "Please rotate your device to landscape mode to complete the form."}
              </div>
            </div>
          </div>
        )}

        <div>
          <div className="row">
            <div className="container-1000">
              {updateFormData.length > 0 ? (
                // Main title of form
                <p className="box-grey-btn main-heading-new onboarding-form-step-title">
                  {updateFormData?.find((y) => y.active)?.label}
                </p>
              ) : (
                ""
              )}
              <div>
                {updateFormData.map((ress: any, index: number) => {
                  return (
                    <React.Fragment key={ress?.formId}>
                      {/* {ress.active ? */}
                      {/* causing multiple form display */}
                      {/* <div className={ress.active ? "d-block" : "d-none"}> */}
                      <div
                        className={index === updateFormData.findIndex((item) => item.active) ? "d-block" : "d-none"}
                      >
                        <Formik
                          initialValues={ress.indata}
                          // validationSchema={validateSchema}
                          enableReinitialize
                          innerRef={(el) => (formRef.current[index] = el)}
                          validateOnBlur={false}
                          onSubmit={(values) => {

                            checkTimeline = "";
                            if (valudatesetformstatus === "draft") {
                              checkIsFormValueChanged(ress);
                              if (countControl?.timelineUpdate) {
                                saveAndEdit();
                              } else {
                                setCountControl((prs) => {
                                  return {
                                    ...prs,
                                    saveModel: true,
                                    saveDraftTest: false,
                                  };
                                });
                              }

                            } else {
                              setCountControl((prs) => {
                                return {
                                  ...prs,
                                  timelineUpdate: false
                                };
                              });
                              formstatus = "";
                              formstatusTwo = false;
                              checkIsFormValueChanged(ress);
                              fileUploadData();

                            }

                          }}
                        >
                          {(formik) => (
                            (
                              // Form start
                              <Form>
                                <div className="row cust-cont-row personal-details" id={`${"personal-details"}-${index}`}>
                                  {ress.fields &&
                                    ress.fields.map((data: any, i: number) => {
                                      return (
                                        <React.Fragment key={i}>
                                          {data.type === "iframe" ? (
                                            <div className="mb-2">
                                              {!data.value ? (
                                                <>
                                                  <Iframe url={data.iframe_url} />
                                                  <div>
                                                    <FormikControl
                                                      control="input"
                                                      type={data.type}
                                                      name={data.name}
                                                      className={
                                                        "form-control d-none "
                                                      }
                                                      allData={data}
                                                      formstatus={formstatus}
                                                    />
                                                  </div>
                                                </>
                                              ) : (
                                                <>
                                                  <div
                                                    className="alert alert-primary"
                                                    role="alert"
                                                  >
                                                    {data.successMessage}
                                                  </div>
                                                </>
                                              )}

                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          {data.type !== "iframe" ? (
                                            <>
                                              {/* //         {(data.parentValue === formik?.values[data.parentName] || data?.parentValues && data?.parentValues?.includes(formik?.values[data.parentName])) ? ( */}
                                              {checkParentMatch(data, formik.values) ? (
                                                <div
                                                  key={data.name}
                                                  className={`${data.className} ${data?.parentWrapperClass} child`}
                                                >
                                                  <div className={`mb-${data?.firstIndexMargin ? data?.firstIndexMargin : 20} first-index`}>
                                                    <div className={`row mb-0 g-1 align-items-center form-group-new ${data?.divWrapperClass}`}>
                                                      {/* ${data.label ? "" : "d-none"} */}
                                                      {data.name !==
                                                        "subForm-1" &&
                                                        data.name !==
                                                        "subForm-2" && data.name !== "subForm-3" ? (
                                                        <div
                                                          className={`${data.lableClass}`}
                                                        >
                                                          <Label
                                                            name={data?.label?.length > 0 ? data.label : ""}
                                                            className={(data.type === "html") ? "heading-md mb-1" : ""} //
                                                            label={data?.label?.length > 0 ? data.label : ""}
                                                            subLabel={
                                                              data.subLabel
                                                            }
                                                            required={
                                                              data.required
                                                            }
                                                          />

                                                          {data?.subText ? (
                                                            <div className="sub-text">
                                                              {data.subText}
                                                            </div>
                                                          ) : (
                                                            ""
                                                          )}


                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}
                                                      {data.description ? (
                                                        <small className="form-description">
                                                          {data.description}
                                                        </small>
                                                      ) : (
                                                        ""
                                                      )}

                                                      <div
                                                        className={
                                                          data.inputClass
                                                        }
                                                      >
                                                        {data.type === "html" && !data?.isHtmlLabel ? (
                                                          <>
                                                            <div
                                                              className="com-html-text"
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  data.value,
                                                              }}
                                                            ></div>
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}

                                                        {data.type === "html" && data?.isHtmlLabel ? (
                                                          <>
                                                            <div
                                                              className="com-html-text"
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  data.htmlLabel,
                                                              }}
                                                            ></div>
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}

                                                        {data?.type === "image" ? (
                                                          <>
                                                            <img src={data?.imageUrl} className="img-fluid" alt={data?.name} />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type ===
                                                          "select" ? (
                                                          <>
                                                            <FormikControl
                                                              control="select"
                                                              type={data.type}
                                                              name={data.name}
                                                              className={
                                                                "form-select"
                                                              }
                                                              allData={data}
                                                              formik={formik}
                                                              completedPage={ress.completedPage}
                                                            />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type === "multiSelect" ? (
                                                          <>
                                                            <FormikControl
                                                              control="multiSelect"
                                                              type={data?.type}
                                                              name={data.name}
                                                              className={"form-select"}
                                                              allData={data}
                                                              formik={formik}
                                                              completedPage={ress.completedPage}
                                                            />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type === "date" ? (
                                                          <>
                                                            <FormikControl
                                                              control="date"
                                                              type={data.type}
                                                              name={data.name}
                                                              className={
                                                                "form-control"
                                                              }
                                                              allData={data}
                                                              dateFormat={
                                                                data.dateFormat
                                                              }
                                                              completedPage={ress.completedPage}
                                                            />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type === "text" ||
                                                          data.type === "number" || data.type === "split-input" ? (
                                                          <>
                                                            <FormikControl
                                                              control={data.type === "split-input" ? data.type : "input"}
                                                              type={data.type}
                                                              name={data.name}
                                                              className={
                                                                "form-control"
                                                              }
                                                              formik={formik}
                                                              onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => data?.isSignature === true ? candidateSignatures(data?.name) : ""}
                                                              completedPage={ress.completedPage}
                                                              // allData={data}
                                                              allData={
                                                                checkValidationElement.filter(
                                                                  (item: any) =>
                                                                    item.child_name ===
                                                                    data.name
                                                                )[0]
                                                                  ?.childValidation
                                                                  ? {
                                                                    ...data,
                                                                    validate:
                                                                      true,
                                                                  }
                                                                  : data
                                                              }
                                                              clearChilInput={clearChilInput}
                                                              doTfnFormValidation={doTfnFormValidation}
                                                            />
                                                            {
                                                              data.isSignature === true && (
                                                                <div className={"model-sign " + data?.name}>
                                                                  {candidateSignModel[data?.name] || ""}
                                                                </div>
                                                              )
                                                            }
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type ===
                                                          "textarea" ? (
                                                          <>
                                                            <FormikControl
                                                              control="textarea"
                                                              type={data.type}
                                                              name={data.name}
                                                              className={
                                                                "form-control"
                                                              }
                                                              allData={data}
                                                            />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type ===
                                                          "radio-group" ? (
                                                          <>
                                                            <FormikControl
                                                              control="radio"
                                                              name={data.name}
                                                              className={
                                                                "form-control"
                                                              }
                                                              option={data.values}
                                                              allData={data}
                                                              formik={formik}
                                                              onClick={clearValueForChildElement()}
                                                              setDoTfnFormValidation={setDoTfnFormValidation}
                                                            />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type ===
                                                          "checkbox-group" ||
                                                          data.type ===
                                                          "checkbox" ? (
                                                          <>
                                                            <FormikControl
                                                              control="checkbox"
                                                              name={data.name}
                                                              className={
                                                                "form-control"
                                                              }
                                                              option={data.values}
                                                              allData={data}
                                                              formik={formik}
                                                              candidateData={candidateData}
                                                              initialCandidateName={`${candidateData?.candidateDetails?.firstName} ${candidateData?.candidateDetails?.lastName}`} />
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {data.type === "file" ? (
                                                          <>
                                                            <>
                                                              {inputTypeFile(
                                                                formik,
                                                                data,
                                                                i
                                                              )}
                                                            </>
                                                          </>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </div>
                                                    </div>
                                                    {data.type === "hr" ? (
                                                      <hr />
                                                    ) : (
                                                      ""
                                                    )}
                                                    {data.status &&
                                                      data.name === "subForm-1" ? (
                                                      <>
                                                        {subForm_1(
                                                          formik,
                                                          ress.fields,
                                                        )}
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                    {data.status &&
                                                      data.name === "subForm-2" ? (
                                                      <>
                                                        {subForm_2(
                                                          formik,
                                                          ress.fields
                                                        )}
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}

                                                    {data.status &&
                                                      data.name === "subForm-3" ? (
                                                      <>
                                                        {subForm_3(
                                                          formik,
                                                          ress.fields,
                                                        )}
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </div>
                                                </div>
                                              ) : (
                                                <>{errorControl(data, formik)}</>
                                              )}
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                                  <div></div>
                                </div>

                                {/* Error Summary */}
                                {
                                  (formik.submitCount > 0 && formik?.errors) && <ErrorSummary errors={formik.errors} />
                                }

                                {/* Iframe Section for e-sign */}
                                <IframeSection
                                  flkState={flkState}
                                />

                                {/* Submit/Next step buttons */}
                                {screenShort.active && (
                                  <FormButtons
                                    screenShort={screenShort}
                                    flkState={flkState}
                                    showEditFlkForm={showEditFlkForm}
                                    handleDynamicFlkEditBtnClick={handleDynamicFlkEditBtnClick}
                                    updateValudatesetFormstatus={updateValudatesetFormstatus}
                                    updateFormData={updateFormData}
                                    ress={ress}
                                    formik={formik}
                                    candidateData={candidateData}
                                  />
                                )}
                              </Form>
                            )
                          )}
                        </Formik>
                        <br />
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Model
        show={saveModel}
        modelHeader={modelHeader()}
        modelBody={modelBody()}
        modelClose={() => closeModel()}
      />
      <Model
        size="lg"
        show={countControl.saveModel}
        modelBody={saveModelBody()}
      />
      <Model size="lg" show={saveAndExitModel} modelBody={confirmMass()} />
    </>
  );
};

export default OnBoarding;
